const messages = {
  es: {
    translations: {
      signup: {
        title: 'Registro',
        toasts: {
          success: '¡Registro realizado con éxito! Inicia sesión para acceder al sistema.',
          fail: 'Error creando el usuario. Verifica la data reportada.',
        },
        form: {
          name: 'Nombre',
          email: 'Correo Electrónico',
          password: 'Contraseña',
          company: 'Nombre de la Empresa',
          phone: 'Whatsapp (COD + NÚMERO)',
        },
        buttons: {
          submit: 'Regístrate',
          login: '¿Ya tienes una cuenta? ¡Inicia sesión!',
        },
      },
      login: {
        title: 'Inicio de Sesión',
        form: {
          email: 'Correo Electrónico',
          password: 'Contraseña',
          button: 'Ingresar',
        },
        buttons: {
          submit: 'Ingresa',
          register: '¿No tienes cuenta? ¡Regístrate!',
        },
      },
      companies: {
        title: 'Registrar Empresa',
        form: {
          name: 'Nombre de la Empresa',
          plan: 'Plan',
          token: 'Token',
          submit: 'Registrar',
          success: 'Empresa creada con éxito!',
        },
      },
      auth: {
        toasts: {
          success: '¡Inicio de sesión exitoso!',
        },
        dueDate: {
          expiration: 'Suscripción caducará en',
          days: 'días!',
          day: 'día!',
          expirationToday: 'Su suscripción termina hoy!',
        },
        token: 'Token',
      },
      dashboard: {
        tabs: {
          indicators: 'Indicadores',
          assessments: 'Evaluaciones',
          attendants: 'Agentes',
        },
        charts: {
          perDay: {
            title: 'Tickets hoy: ',
          },
        },
        cards: {
          inAttendance: 'Atención actual',
          waiting: 'Esperando',
          activeAttendants: 'Agentes Activos',
          finalized: 'Finalizados',
          newContacts: 'Nuevos Contactos',
          totalReceivedMessages: 'Total de Mensajes Recibidas',
          totalSentMessages: 'Total de Mensajes Enviadas',
          averageServiceTime: 'T.P. de Atención',
          averageWaitingTime: 'T.P. de Espera',
          status: 'Status (Actual)',
        },
        users: {
          name: 'Nombre',
          numberAppointments: 'Total de tickets',
          statusNow: 'Actual',
          totalCallsUser: 'Total de atención por usuario',
          totalAttendances: 'Total de atenciones',
        },
        date: {
          initialDate: 'Fecha Inicial',
          finalDate: 'Fecha Final',
        },
        licence: {
          available: 'Disponíble hasta',
        },
        assessments: {
          totalCalls: 'Total de Tickets',
          callsWaitRating: 'Tickets aguardando evaluación',
          callsWithoutRating: 'Ticket sin evaluación',
          ratedCalls: 'Tickets evaluados',
          evaluationIndex: 'Índice de evaluación',
          score: 'Puntaje',
          prosecutors: 'Promotores',
          neutral: 'Neutrales',
          detractors: 'Dectratores',
        },
      },
      reports: {
        title: 'Reporte de Pesquisas Realizadas',
        operator: 'Agente',
        period: 'Período',
        until: 'Hasta',
        date: 'Fecha',
        reportTitle: 'Relatorios',
        calls: 'Atenciones',
        search: 'Pesquisas',
        durationCalls: 'Duración de la atención',
        grupoSessions: 'Atención en grupos grupos',
        groupTicketsReports: {
          timezone: 'America/Monterrey',
          msgToast: 'Generando relatorio compactado, por favor espere.',
          errorToast: 'Erro ao generar relatorio',
          back: 'Volver',
          groupServiceReport: 'Relatorio de Atención en Grupos',
          loading: 'Cargando...',
          contact: 'Contacto',
          dateOpen: 'Fecha de Apertura',
          dateLastUpdated: 'Fecha Ultima Actualización',
          agent: 'Agente',
          agentClosed: 'Agente(cerró)',
          waitingAssistance: 'Esperando atención',
          process: 'En proceso',
        },
        researchReports: {
          response: 'respuesta',
          active: '(Activa)',
          inactive: '(Inactiva)',
          quantity: 'Cantidade',
          percentage: 'porcentaje',
          title: 'Relatorio de Pesquisas Realizadas',
          activeSearch: 'Pesquisa activa',
          inactiveSearch: 'Pesquisa inactiva',
        },
        ticketDurationDetail: {
          msgToast: 'Generando relatorio compactado, por favor espere.',
          title: 'Relatorio de Duración de la Atención',
          startService: 'Início de la Atención',
          lastUpdated: 'Última actualización',
          lastAgent: 'Último agente',
          durationFinished: 'Duración después de finalizado',
        },
        ticketDuration: {
          title: 'Relatorio de Duración de Atención',
          contact: 'Contacto',
          open: 'Abiertos',
          pending: 'Pendientes',
          finished: 'Finalizados',
          durationFinished: 'Duración de los finalizados',
          durationAfterFinished: 'Duración después de finalizado',
          actions: 'Acciones',
        },
        ticketReports: {
          msgToast: 'Generando relatorio compactado, por favor aguarde.',
          title: 'Relatrio de Atención',
        },
        pdf: {
          title: 'Relación de Atenciones Realizadas',
          exportTitle: 'Relación de Atenciones en Grupos Realizadas',
        },
      },
      todo: {
        newTask: 'Nueva Tarea',
        add: 'Agregar',
        task: 'Tareas',
      },
      contactImportWpModal: {
        title: 'Exportar Contactos para Excel',
        exportSuccess: '¡Exportación completada con éxito!',
        buttons: {
          downloadModel: 'Download - modelo de excel para importación',
          closed: 'Cerrar',
          import: 'Seleccione el archivo de excel para importar los Contactos',
        },
      },
      connections: {
        title: 'Conexiones',
        waitConnection: 'Espere... Las conexiones serán reiniciadas!',
        newConnection: 'Nueva Conexión',
        restartConnections: 'Reiniciar Conexiones',
        callSupport: 'Soporte',
        toasts: {
          deleted: '¡La conexión de WhatsApp ha sido borrada satisfactoriamente!',
          disconnected: '¡Conexión desconectada con éxito!',
          closedimported: 'Estamos cerrando los tickets importados, por favor espere.',
        },
        facebook: {
          success: '¡Conexión Facebook/Instagram conectada con éxito!',
          errorConfig: 'Configuración de Facebook no disponible.',
          connecting: 'Conectando...',
          redirecting: 'Redirigiendo...',
          errorRedirect: 'Error. Redirigiendo...',
          errorNoUserId: 'No se pudo obtener el ID del usuario.',
        },
        confirmationModal: {
          closedImportedTitle: 'Cerrar tickets importados',
          closedImportedMessage: '¿Seguro? Todos los tickets importados seran cerrados.',
          deleteTitle: 'Borrar',
          deleteMessage: '¿Estás seguro? Este proceso no puede ser revertido.',
          disconnectTitle: 'Desconectar',
          disconnectMessage: 'Estás seguro? Deberá volver a leer el código QR',
          disconnectMetaMessage:
            '¿Estás seguro? La integración con Facebook/Instagram será desconectada.',
        },
        buttons: {
          add: 'Agrega WhatsApp',
          disconnect: 'Desconectar',
          tryAgain: 'Inténtalo de nuevo',
          qrcode: 'QR CODE',
          newQr: 'Nuevo QR CODE',
          closedImported: 'Cerrar todos los tickets Importados',
          preparing: 'Preparando mensajes para importación',
          importing: 'Importando Mensajes del WhatsApp',
          processed: 'Processado',
          in: 'de',
          connecting: 'Conectando',
        },
        typography: {
          processed: 'Processado',
          in: 'de',
          date: 'Fecha del mensaje',
        },
        toolTips: {
          disconnected: {
            title: 'No se pudo iniciar la sesión de WhatsApp',
            content:
              'Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR',
            titleMeta: 'Error al conectar con Facebook/Instagram',
            contentMeta:
              'Se perdió la conexión con Facebook o Instagram. Haga clic en reconectar para reautorizar.',
          },
          qrcode: {
            title: 'Esperando la lectura del código QR',
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: 'Conexión establecida',
          },
          timeout: {
            title: 'Se perdió la conexión con el teléfono celular',
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: 'Nombre',
          status: 'Estado',
          lastUpdate: 'Última Actualización',
          default: 'Por Defecto',
          actions: 'Acciones',
          session: 'Sesión',
          number: 'Número de Whatsapp',
        },
      },
      showTicketOpenModal: {
        title: {
          header: 'Servicio existente',
        },
        form: {
          message: 'Hay un ticket abierto para este contacto:',
          user: 'Agente',
          queue: 'Fila',
          messageWait: 'Este contacto ya está en espera.',
        },
      },
      showTicketLogModal: {
        title: {
          header: 'Historial del ticket',
          subtitle: 'Línea de tiempo de la atención',
        },
        empty: 'No se encontraron registros.',
        end: 'Inicio del historial',
        system: 'Sistema',
        meta: {
          from: 'De',
          queue: 'Departamento',
          user: 'Agente',
          reason: 'Motivo',
          comment: 'Observación',
          client: 'Cliente',
          tag: 'Etiqueta',
          waited: 'Tiempo de espera',
          opportunity: 'Oportunidad',
          pipeline: 'Embudo',
          stage: 'Etapa',
          value: 'Valor',
          note: 'Nota',
        },
        options: {
          create: 'Ticket creado.',
          chatBot: 'ChatBot iniciado.',
          queue: ' - Fila definida.',
          open: 'iniciou la atención.',
          access: 'accesó el ticket.',
          transfered: 'transferió el ticket.',
          receivedTransfer: 'recibió el ticket transferido.',
          pending: 'regresó a la fila.',
          closed: 'cerró el ticket',
          reopen: 'abrió el ticket',
          redirect: '- redirigido',
          autoClose: 'cerrado automáticamente.',
          userDefine: 'definió el agente.',
          nps: 'evaluación (NPS).',
          delete: 'eliminó el ticket.',
          retriesLimitQueue: 'límite de intentos en la fila.',
          retriesLimitUserDefine: 'límite de intentos del agente.',
          linkClient: 'vinculó un cliente.',
          tagAdded: 'agregó una etiqueta.',
          tagRemoved: 'quitó una etiqueta.',
          leadValueChanged: 'cambió el valor del lead.',
          firstResponse: 'respondió por primera vez.',
          opportunityLinked: 'creó una oportunidad en el CRM.',
          noteAdded: 'agregó una observación interna.',
        },
      },
      closeTicketReasonModal: {
        title: 'Finalizar atención',
        subtitle: 'Seleccione el motivo del cierre',
        reasonLabel: 'Motivo',
        reasonRequired: 'Seleccione un motivo para cerrar',
        noReasons: 'Ningún motivo registrado. Regístrelo en Configuración.',
        commentLabel: 'Observación (opcional)',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Finalizar',
        },
      },
      whatsappModal: {
        title: {
          add: 'Agrega WhatsApp',
          edit: 'Edita WhatsApp',
        },
        tabs: {
          general: 'Geral',
          messages: 'Mensajes',
          assessments: 'Evaluaciones',
          integrations: 'Integraciones',
          schedules: 'Horario de trabajo',
        },
        form: {
          importOldMessagesEnable: 'Importar mensajes del celular',
          importOldMessages: 'Fecha de inicio',
          importRecentMessages: 'Fecha Final',
          closedTicketsPostImported: 'Cerrar tickets después de la importación',
          name: 'Nombre',
          queueRedirection: 'Redirección de Fila',
          queueRedirectionDesc:
            'Seleccione una fila para los contactos que no tienen una fila para redirigir',
          default: 'Por Defecto',
          group: 'Permitir grupos',
          timeSendQueue: 'Tiempo en minutos para redireccionar a la fila',
          importAlert:
            'ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes',
          importMax30Days: 'El período de importación no puede exceder 30 días',
          importMax30DaysHint: 'Máximo 30 días entre las fechas',
          allowGroup: 'Permitir grupos',
          groupAsTicket: 'Grupos como Ticket',
          maxUseBotQueues: 'Cantidad máxima de veces que el chatbot va a ser enviado',
          timeUseBotQueues: 'Tiempo en minutos para nuevo envío del chatbot',
          expiresTicket: 'Cerrar chats abiertos após *n* horas',
          expiresTicketNPS: 'Cerrar chats aguardando la evaluacion luego de x minutos',
          maxUseBotQueuesNPS: 'Cantidad máxima de veces que la evaluación será enviada',
          closeLastMessageOptions1: 'Del Agente/Cliente',
          closeLastMessageOptions2: 'Del Agente',
          outOfHoursMessage: 'Mensaje fuera de horario de atención',
          greetingMessage: 'Mensaje de saludo',
          complationMessage: 'Mensaje de conclusión',
          lgpdLinkPrivacy: 'Link para políticas de privacidad',
          lgpdMessage: 'Mensaje inicial de LPD',
          lgpdDeletedMessages: 'Ofuscar mensaje borrada por el contacto',
          lgpdSendMessage: 'Siempre solicitar confirmación del contacto',
          ratingMessage: 'Mensaje de evaluación - Rango de 0 a 10',
          token: 'Token para integración externa',
          sendIdQueue: 'Fila',
          inactiveMessage: 'Mensaje de inactividad',
          timeInactiveMessage: 'Tiempo em minutos para el envío del aviso de inactividad',
          whenExpiresTicket: 'Cerrar chats abiertos cuando el último mensaje sea',
          expiresInactiveMessage: 'Mensaje al cerrar por inactividade',
          prompt: 'Prompt',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
        },
        menuItem: {
          enabled: 'Activado',
          disabled: 'Desactivado',
          minutes: 'minutos',
        },
        success: 'WhatsApp guardado satisfactoriamente.',
        errorSendQueue:
          'Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.',
        errorExpiresNPS:
          'Ingrese el tiempo de cierre de chats en espera de evaluación — obligatorio ya que la conexión está configurada para evaluar atenciones.',
      },
      qrCode: {
        message: 'Lée el código QR para empezar la sesión.',
      },
      contacts: {
        title: 'Contactos',
        toasts: {
          deleted: '¡Contacto borrado satisfactoriamente!',
        },
        searchPlaceholder: 'Buscar...',
        confirmationModal: {
          deleteTitle: 'Borrar',
          importTitlte: 'Importar contactos',
          exportContact: 'Exportar contactos',
          deleteMessage:
            '¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.',
          blockContact: '¿Estás seguro que quieres bloquear este contacto?',
          unblockContact: '¿Estás seguro que quieres desbloquear este contacto?',
          importMessage: '¿Quieres importar todos los contactos del teléfono?',
          importChat: 'Importar Conversaciones',
          wantImport: '¿Quieres importar todas las conversaciones del teléfono?',
        },
        buttons: {
          import: 'Importar Contactos',
          add: 'Nuevo contacto',
          export: 'Exportar Contacto',
        },
        table: {
          name: 'Nombre',
          whatsapp: 'WhatsApp',
          email: 'Correo Electrónico',
          actions: 'Acciones',
          lastMessage: 'Ultimo Mensaje',
        },
        menu: {
          importYourPhone: 'Importar del celular por default',
          importToExcel: 'Importar / Exportar del Excel',
        },
      },
      forwardMessage: {
        text: 'Reenviada',
      },
      forwardMessageModal: {
        title: 'Reenviar mensaje',
        buttons: {
          ok: 'Reenviar',
        },
      },
      promptModal: {
        form: {
          name: 'Nombre',
          prompt: 'Prompt',
          voice: 'Voz',
          max_tokens: 'Máximo de Tokens en la respuesta',
          temperature: 'Temperatura',
          apikey: 'API Key',
          max_messages: 'Máximo de mensajes del Historico',
          voiceKey: 'Llave de la API de la Voz',
          voiceRegion: 'Región de la Voz',
        },
        success: 'Agente IA guardado',
        title: {
          add: 'Agregar agente IA',
          edit: 'Editar agente IA',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
          save: 'Guardar agente',
        },
        subtitle: 'Configure su agente en pocos pasos y publique con seguridad.',
        tabs: {
          start: 'Inicio',
          tools: 'Herramientas',
          knowledge: 'Conocimiento',
        },
        sections: {
          agentName: 'Nombre del agente',
          serviceQueue: 'Sector de atención',
          mainPrompt: 'Prompt principal',
          aiConfig: 'Configuración de IA',
          tools: 'Herramientas disponibles para este agente IA',
          knowledge: 'Base de conocimiento',
        },
        quickStart: {
          title: 'Inicio rápido',
          description: 'Empiece por lo básico para publicar su agente sin confusión.',
          step1: 'Defina nombre y sector',
          step2: 'Escriba el prompt principal',
          step3: 'Elija modelo de IA',
        },
        hints: {
          agentName: 'Elija un nombre corto y fácil de identificar.',
          serviceQueue: 'Defina en qué fila actuará este agente (obligatorio).',
          mainPrompt: 'Escriba el comportamiento del agente, tono de voz y límites de respuesta.',
          aiConfigByok: 'Elija el proveedor, modelo y configure el acceso de IA para este agente.',
          aiConfigPlatform:
            'Elija el proveedor y modelo de IA. Los créditos del plan se usarán automáticamente.',
          noProvider:
            'Ningún proveedor de IA configurado. Solicite al administrador que configure las claves de API en la sección de Créditos de IA.',
          platformCredits:
            'Este agente usará créditos del plan para procesar las respuestas de IA.',
          tools:
            'Marque solo las herramientas que este agente debe usar. Las funciones sensibles quedan deshabilitadas hasta que las active explícitamente.',
          knowledge:
            'Envíe PDFs, imágenes o registre enlaces para proporcionar contexto adicional a la IA.',
        },
        aiProvider: {
          label: 'Proveedor de IA',
          model: 'Modelo',
          mode: 'Modo de uso de IA',
          modeAuto: 'Automático',
          modeByok: 'Mi clave API',
          modePlatform: 'Créditos del plan',
          modeAutoDesc: 'Usa clave propia si disponible, sino créditos del plan',
          modeByokDesc: 'Usa solo la clave configurada en este agente',
          modePlatformDesc: 'Usa solo créditos de la plataforma, ignora clave propia',
          freeLabel: 'Gratis',
        },
        tools: {
          sensitive: 'Sensible',
          active: 'Activa para este agente',
          inactive: 'Desactivada',
        },
        knowledge: {
          addImage: 'Agregar imagen',
          uploading: 'Enviando...',
          selectImage: 'Seleccionar imagen',
          addLink: 'Agregar enlace',
          linkTitle: 'Título del enlace',
          linkUrl: 'URL (https://...)',
          addButton: 'Agregar',
          resources: 'Recursos agregados',
          empty:
            'Ningún contenido registrado aún. Agregue archivos o enlaces para disponibilizar conocimiento a la IA.',
          defaultTitle: 'Enlace guardado',
          imageLabel: 'Imagen',
          linkLabel: 'Enlace',
          open: 'Abrir',
          copyLink: 'Copiar enlace',
          remove: 'Eliminar',
        },
        validation: {
          queueRequired: 'Seleccione el sector de atención',
          promptRequired: 'Informe el prompt principal',
          apiKeyRequired: 'Informe la API Key',
          providerRequired: 'Seleccione el proveedor de IA',
          providerUnavailable: 'Proveedor no disponible — clave de API no configurada',
          modelRequired: 'Seleccione el modelo de IA',
        },
        toasts: {
          linkCopied: '¡Enlace copiado!',
          copyError: 'No fue posible copiar el enlace.',
          uploadError: 'No fue posible enviar el archivo.',
          fileAdded: '¡Archivo agregado a la base de conocimiento!',
          linkTitleRequired: 'Informe el título y el enlace.',
          invalidUrl: 'Informe un enlace válido (https://...).',
          linkAdded: '¡Enlace agregado a la base de conocimiento!',
        },
      },
      prompts: {
        title: 'Agentes IA',
        table: {
          name: 'Nombre',
          queue: 'Sector/Fila',
          max_tokens: 'Máximo Tokens Respuestas',
          actions: 'Acciones',
          agent: 'Agente',
          sector: 'Sector',
          maxTokens: 'Max tokens',
          tools: 'Herramentas',
          noTools: 'Ninguna',
          noQueue: 'Sin fila',
          edit: 'Editar',
          editAgent: 'Editar agente',
          delete: 'Eliminar',
          deleteAgent: 'Eliminar agente',
        },
        page: {
          title: 'Agentes de IA',
          subtitle: 'Configure agentes inteligentes para responder clientes',
          search: 'Buscar agente IA...',
          addButton: 'Nuevo agente',
          addTooltip: 'Agregar agente IA',
          agentCount_one: 'agente IA configurado',
          agentCount_other: 'agentes IA configurados',
          expandedAriaLabel: 'Detalles del agente {{name}}',
          rowsPerPage: 'Filas:',
          displayedRows: '{{from}}-{{to}} de {{count}}',
        },
        messages: {
          noOpenAiPermission:
            '¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.',
        },
        expandedPanel: {
          sections: {
            agentAndSector: 'Agente y sector',
            modelAndParams: 'Modelo y parámetros',
            mainPrompt: 'Prompt principal',
            toolsAndKnowledge: 'Herramientas y conocimiento',
            keysHidden: 'Claves (ocultas)',
            tokenUsage: 'Uso de tokens',
            registry: 'Registro',
          },
          fields: {
            id: 'ID',
            name: 'Nombre',
            companyId: 'Empresa (ID)',
            sector: 'Sector',
            queueId: 'Fila (ID)',
            provider: 'Proveedor',
            model: 'Modelo',
            temperature: 'Temperatura',
            maxTokens: 'Max. tokens',
            maxMessages: 'Max. mensajes',
            voice: 'Voz',
            text: 'Texto',
            activeTools: 'Herramientas activas',
            kbItems: 'Ítems en la base',
            apiKey: 'API (IA)',
            voiceKey: 'Voz (key)',
            voiceRegion: 'Región de voz',
            promptTokens: 'Prompt',
            completionTokens: 'Conclusión',
            totalTokens: 'Total',
            createdAt: 'Creado en',
            updatedAt: 'Actualizado en',
          },
          yes: 'Sí',
          no: 'No',
          none: 'Ninguna',
          notConfigured: 'No configurada',
          hiddenShort: '•••••••• (oculto)',
          hiddenPartial: '{{start}}…{{end}} (oculto)',
          providers: {
            openai: 'OpenAI',
            gemini: 'Google Gemini',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: '¿Estás seguro? ¡Esta acción no se puede revertir!',
        },
        buttons: {
          add: 'Agregar agente IA',
        },
      },
      iaWorkflow: {
        page: {
          title: 'Workflow de IA',
          subtitle: 'Configure el orquestador de IA y conecte agentes especializados',
        },
        sections: {
          data: 'Datos del workflow',
          orchestrator: 'Agente IA orquestador',
          agents: 'Agentes conectados',
        },
        form: {
          name: 'Nombre del workflow',
          nameHelp: 'Ej.: Atención SDR, Soporte N2',
          description: 'Descripción',
          orchestratorHint: 'Seleccione el agente IA que será el cerebro/orquestador:',
          agentAlias: 'Alias del agente',
          agentAliasHelp: 'Nombre mostrado en la ejecución del workflow',
          selectAgentIa: 'Seleccionar agente IA',
          searchAgent: 'Buscar agente',
          searchAgentIa: 'Buscar agente IA',
        },
        buttons: {
          addAgent: 'Agregar agente',
          saveWorkflow: 'Guardar workflow',
          saving: 'Guardando...',
          close: 'Cerrar',
          cancel: 'Cancelar',
          saveChanges: 'Guardar cambios',
        },
        modal: {
          editTitle: 'Editar agente',
          addTitle: 'Agregar agente',
          subtitle: 'Configure el agente y seleccione un agente IA',
        },
        messages: {
          noAgents: 'Ningún agente agregado aún.',
          loading: 'Cargando workflow de IA...',
          saveSuccess: 'Workflow guardado con éxito',
          noPermission: 'No tiene permiso para acceder a este editor.',
        },
        validation: {
          nameRequired: 'Informe un nombre para el workflow.',
          nameMinLength: 'Use al menos 3 caracteres en el nombre.',
          orchestratorRequired: 'Seleccione un agente IA orquestador.',
          agentsRequired: 'Agregue al menos un agente al workflow.',
          agentsDuplicate: 'Existen agentes duplicados con el mismo agente IA y alias.',
          agentIaRequired: 'Seleccione un agente IA.',
          agentAliasRequired: 'Informe un alias para el agente.',
          agentAliasExists: 'Ya existe un agente con ese agente IA y alias.',
        },
      },
      contactModal: {
        title: {
          add: 'Agregar contacto',
          edit: 'Editar contacto',
        },
        form: {
          mainInfo: 'Detalles del contacto',
          extraInfo: 'Información adicional',
          name: 'Nombre',
          number: 'Número de Whatsapp',
          email: 'Correo Electrónico',
          extraName: 'Nombre del Campo',
          extraValue: 'Valor',
          chatBotContact: 'Desactivar chatbot para este contacto',
          termsLGDP: 'Términos P.P. aceptados en:',
          allTicket: 'Visualizar tickets sin fila',
          allowGroup: 'Permitir grupos',
        },
        buttons: {
          addExtraInfo: 'Agregar información',
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
        },
        success: 'Contacto guardado satisfactoriamente.',
      },
      queueModal: {
        title: {
          queueData: 'Datos de la fila',
          text: 'Horarios de atención',
          add: 'Agregar fila',
          edit: 'Editar fila',
          confirmationDelete: '¿Está seguro? Todas las opciones integradas también se eliminarán.',
        },
        form: {
          name: 'Nombre',
          color: 'Color',
          orderQueue: 'Orden de la fila (Bot)',
          rotate: 'Rotativo',
          timeRotate: 'Tiempo de Rotación',
          greetingMessage: 'Mensaje de saludo',
          complationMessage: 'Mensaje de cierre',
          outOfHoursMessage: 'Mensaje fuera de horario de atención',
          token: 'Token',
          integrationId: 'Integración',
          fileListId: 'Listado de archivos',
          closeTicket: 'Cerrar ticket',
          queueType: 'Tipo de menu',
          message: 'Mensaje de respuesta',
          queue: 'Fila para transferencia',
          integration: 'Integración',
          file: 'Listado de archivos',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
        },
        bot: {
          title: 'Opciones',
          toolTipTitle: 'Agregue las opciones para construir un chatbot',
          toolTip:
            'Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.',
          selectOption: 'Seleccione una opción',
          text: 'Texto',
          attendent: 'Agente',
          queue: 'Fila',
          integration: 'Integranción',
          file: 'Archivo',
          toolTipMessageTitle: 'El mensaje es obligatorio para pasar al siguiente nivel',
          toolTipMessageContent: 'El mensaje es obligatorio para pasar al siguiente nivel',
          selectUser: 'Seleccione un Usuario',
          selectQueue: 'Seleccione una Fila',
          selectIntegration: 'Seleccione um Integración',
          addOptions: 'Agregar opciones',
        },
        serviceHours: {
          dayWeek: 'Día',
          startTimeA: 'Hora de Inicio',
          endTimeA: 'Hora del término',
          startTimeB: 'Hora de Inicio',
          endTimeB: 'Hora del término',
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sabado',
          sunday: 'Domingo',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Agregar proyecto',
          edit: 'Editar proyecto',
        },
        form: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nombre',
          projectName: 'Nombre del Proyecto',
          language: 'Idioma',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Tiempo en minutos para expirar una conversación',
          typebotKeywordFinish: 'Palabra para finalizar la conversación',
          typebotUnknownMessage: 'Mensaje de opción invalida',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
          test: 'Probar Bot',
        },
        messages: {
          testSuccess: '¡Integración testada con éxito!',
          addSuccess: '¡Integración agregada con éxito!',
          editSuccess: '¡Integración editada con éxito!',
        },
      },
      userModal: {
        warning: 'Para importar los mensajes por favor vuelva a leer el QRCode.',
        title: {
          add: 'Agregar usuario',
          edit: 'Editar usuario',
          updateImage: 'Actualizar Imagen',
          removeImage: 'Excluir Imagen',
        },
        form: {
          name: 'Nombre',
          email: 'Correo Electrónico',
          password: 'Contraseña',
          farewellMessage: 'Mensaje de despedida',
          profile: 'Perfil',
          profileOwner: 'Propietario',
          profileSuperAdmin: 'Super Admin',
          startWork: 'Inicio del Horario',
          endWork: 'Final del Horario',
          whatsapp: 'Conexión Defautl',
          allTicketEnable: 'Activado',
          allTicketDisable: 'Desactivado',
          allTicket: 'Visualizar mensajes sin fila',
          allowGroup: 'Permitir Grupos',
          defaultMenuOpen: 'Abierto',
          defaultMenuClosed: 'Cerrado',
          defaultMenu: 'Menu Estándar',
          allHistoric: 'Ver historicos',
          allHistoricEnabled: 'Activado',
          allHistoricDisabled: 'Desactivado',
          allUserChat: 'Ver conversación de otros usuarios',
          userClosePendingTicket: 'Permitir cerrar tickets pendientes',
          showDashboard: 'Ver Dashboard',
        },
        tabs: {
          general: 'General',
          permissions: 'Permissos',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
          addImage: 'Agregar Imagen',
          editImage: 'Editar Imagen',
        },
        success: 'Usuario guardado satisfactoriamente.',
      },
      companyModal: {
        title: {
          add: 'Agregar empresa',
          edit: 'Editar empresa',
        },
        form: {
          name: 'Nombre',
          email: 'Correo electrónico',
          passwordDefault: 'Contraseña',
          numberAttendants: 'Usuarios',
          numberConections: 'Conexiones',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
        },
        success: 'La Empresa fue guardada satisfactoriamente.',
      },
      scheduleModal: {
        title: {
          add: 'Nuevo Programa',
          edit: 'Editar Programa',
        },
        form: {
          body: 'Mensaje',
          contact: 'Contacto',
          sendAt: 'Fecha del Programa',
          sentAt: 'Fecha de Envío',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
          close: 'Cerrar',
        },
        success: 'Programa guardado satisfactoriamente.',
        confirmationModal: {
          deleteTitle: 'Eliminar adjunto',
          deleteMessage: '¿Está seguro de que desea eliminar este adjunto?',
        },
        toasts: {
          deleted: 'Adjunto eliminado satisfactoriamente.',
        },
      },
      contactTagPicker: {
        title: 'Agregar etiqueta',
        subtitle: 'Haz clic para seleccionar o quitar',
        searchPlaceholder: 'Buscar etiqueta...',
        close: 'Cerrar',
        empty: 'Ninguna etiqueta encontrada',
        emptyNoTags: 'Aún no tienes etiquetas registradas.',
        emptyNoTagsHint: 'Crea etiquetas para organizar y filtrar tus contactos.',
        emptySearch: 'Ninguna etiqueta coincide con tu búsqueda.',
        createTags: 'Crear etiquetas',
      },
      tagModal: {
        title: {
          add: 'Nueva Tag',
          edit: 'Editar Tag',
          addKanban: 'Nueva Lane',
          editKanban: 'Editar Lane',
        },
        form: {
          name: 'Nombre',
          color: 'Color',
          timeLane: 'Horas hasta redireccionar',
          timeLaneHelper:
            'Tras este intervalo (en horas), el ticket puede moverse al tablero de destino.',
          nextLaneId: 'Tablero de destino',
          greetingMessageLane: 'Mensaje de bienvenida',
          greetingMessageLaneHelper: 'Texto asociado a este tablero en el Kanban.',
          rollbackLaneId: 'Tablero al reanudar',
          rollbackLaneHelper: 'Tablero al que vuelve el ticket cuando se reanuda la atención.',
        },
        buttons: {
          okAdd: 'Agregar',
          okEdit: 'Guardar',
          cancel: 'Cancelar',
        },
        success: 'Tag guardada satisfactoriamente.',
        successKanban: 'Lane guardada satisfactoriamente.',
      },
      fileModal: {
        title: {
          add: 'Agregar menú de evaluación',
          edit: 'Editar menú de evaluación',
        },
        buttons: {
          okAdd: 'Guardar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
          fileOptions: 'Agregar archivo',
        },
        form: {
          name: 'Nombre',
          message: 'Mensaje de Evaluación',
          options: 'Opciones de Evaluación',
          extraName: 'Nombre de la opción',
          extraValue: 'Valor de la opción',
        },
        success: 'Evaluación guardada satisfactoriamente.',
      },
      chat: {
        noTicketMessage: 'Selecciona un ticket para empezar a chatear.',
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: '⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️',
          titleFileList: 'Listado de archivo(s)',
        },
      },
      chatInternal: {
        new: 'Nuevo',
        widget: {
          hubKicker: 'Chat empresa',
          hubHeadline: 'Hola, ¿en qué podemos ayudarte?',
          hubSubline: 'Solemos responder en pocos minutos.',
          searchPlaceholder: 'Buscar conversaciones…',
          emptyList: 'No se encontró ninguna conversación.',
          emptyThread: 'Aún no hay mensajes. Envía el primero.',
          newConversation: 'Nueva conversación',
          typeMessage: 'Escribe un mensaje…',
        },
        header: {
          back: 'Volver a la lista',
          subtitle: 'Creado por {{name}} · ',
          subtitleOwnerOnly: 'Creado por {{name}}',
          subtitleDateOnly: 'Creado el ',
        },
        media: {
          attach: 'Adjuntar archivo (un archivo por envío)',
          recordAudio: 'Grabar audio',
          recordStop: 'Detener grabación',
          recordCancel: 'Cancelar grabación',
          recordConfirm: 'Enviar audio grabado',
          send: 'Enviar mensaje',
          recordError: 'No se pudo usar el micrófono. Compruebe el permiso del navegador.',
          recordUnsupported: 'Su navegador no admite grabación de audio aquí.',
          recordingPlaceholder: 'Grabando audio…',
          attachmentPreview: {
            title: 'Adjunto',
            remove: 'Quitar',
            send: 'Enviar',
            imageAlt: 'Vista previa de la imagen',
            videoLabel: 'Vista previa del vídeo',
            audioHint: 'Archivo de audio',
            fileHint: 'Vista previa no disponible para este tipo de archivo',
          },
        },
        modal: {
          conversation: 'Inicio',
          title: 'Título',
          titleRequired: 'Indica un título para la conversación.',
          filterUsers: 'Filtro por Usuarios',
          cancel: 'Cerrar',
          save: 'Guardar',
        },
        modalDelete: {
          title: 'Excluir Chat',
          message: 'Esta acción no se puede revertir, ¿confirmar?',
        },
        deleteMessage: 'Eliminar mensaje',
        deleteMessageConfirm:
          '¿Eliminar este mensaje para todos? Esta acción no se puede deshacer.',
        deleteModal: {
          title: 'Eliminar mensaje',
          question: '¿Seguro que deseas eliminar este mensaje?',
          subtext: 'Esta acción no se puede deshacer.',
          confirm: 'Eliminar',
          cancel: 'Cancelar',
          previewAudio: 'Audio',
          previewImage: 'Foto',
          previewVideo: 'Video',
          previewDocument: 'Documento',
        },
      },
      ticketsManager: {
        questionCloseTicket: '¿Quieres cerrar todos los tickets?',
        yes: 'SI',
        not: 'NO',
        buttons: {
          newTicket: 'Nuevo',
          resolvAll: 'Resolver Todos',
          close: 'Cerrar',
          new: 'Nuevo',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Filas',
      },
      tickets: {
        inbox: {
          closedAllTickets: '¿Cerrar todos los tickets?',
          closedAll: 'Cerrar Todos',
          newTicket: 'Nuevo Ticket',
          yes: 'SI',
          no: 'NO',
          open: 'Abiertos',
          resolverd: 'Resueltos',
        },
        toasts: {
          deleted: 'El ticket en el que estabas ha sido borrado.',
        },
        notification: {
          message: 'Mensaje de',
        },
        tabs: {
          open: { title: 'Bandeja' },
          closed: { title: 'Resueltos' },
          search: { title: 'Buscar' },
        },
        search: {
          placeholder: 'Buscar tickets y mensajes.',
          filterConections: 'Filtro por Conexión',
          filterConectionsOptions: {
            open: 'Abierto',
            closed: 'Cerrado',
            pending: 'Pendiente',
          },
          filterUsers: 'Filtro por usuarios',
        },
        buttons: {
          showAll: 'Todos',
          returnQueue: 'Regresar a la Fila',
          scredule: 'Programar',
          deleteTicket: 'Borrar Ticket',
          quickmessageflash: 'Mensaje Rápido',
        },
        closedTicket: {
          closedMessage: 'Cerrar CON un mensaje de despedida',
          closedNotMessage: 'Cerrar SIN un mensaje de despedida',
        },
        confirmationModal: {
          deleteTitle: 'Eliminar ticket',
          deleteMessage: '¿Realmente desea eliminar este ticket?',
          closeTitle: 'Cerrar ticket',
          closeMessage: '¿Realmente desea cerrar este ticket?',
          ignoreTitle: 'Ignorar ticket',
          ignoreMessage: '¿Realmente desea ignorar este ticket?',
        },
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        subtitle: 'Elija el agente (opcional) y el departamento de destino.',
        close: 'Cerrar',
        fieldLabel: 'Escriba para buscar usuarios',
        fieldQueueLabel: 'Transferir para fila',
        fieldQueuePlaceholder: 'Seleccione una fila',
        fieldWhatsapp: 'Seleccione un whatsapp',
        noOptions: 'No se encontraron usuarios con ese nombre',
        msgTransfer: 'Observación - los mensajes internos, no serán visualizados por el cliente.',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar',
        },
      },
      ticketsList: {
        called: 'Entradas',
        today: 'Hoy',
        missedCall: 'Llamada de voz/vídeo perdida a las',
        pendingHeader: 'Esperando',
        assignedHeader: 'Trabajando en',
        groupingHeader: 'Grupos',
        noTicketsTitle: 'Ningún ticket encontrado',
        noTicketsMessage:
          'No se encontraron tickets en esta pestaña con los filtros o término de búsqueda actuales.',
        noQueue: 'Sin Fila',
        buttons: {
          accept: 'Aceptar',
          cancel: 'Cancelar',
          start: 'Iniciar',
          closed: 'Cerrar',
          reopen: 'Reabrir',
          transfer: 'Transferir',
          ignore: 'Ignorar',
          exportAsPDF: 'Exportar para PDF',
        },
        acceptModal: {
          title: 'Aceptar Chat',
          queue: 'Seleccionar tag',
        },
      },
      newTicketModal: {
        title: 'Crear Ticket',
        fieldLabel: 'Escribe para buscar un contacto',
        add: 'Agregar',
        buttons: {
          ok: 'Guardar',
          cancel: 'Cancelar',
        },
      },
      SendContactModal: {
        title: 'Enviar contacto',
        fieldLabel: 'Buscar contacto',
        add: 'Agregar',
        buttons: {
          ok: 'Enviar',
          cancel: 'Cancelar',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Conexiones',
          chatsTempoReal: 'Panel de Asistencia',
          tickets: 'Inbox',
          quickMessages: 'Respuestas Rápidas',
          contacts: 'Contactos',
          queues: 'Filas',
          tags: 'Tags',
          administration: 'Administración',
          companies: 'Empresas',
          users: 'Usuarios',
          settings: 'Configuración',
          ratings: 'Regist. Evaluaciones',
          helps: 'Ayuda',
          messagesAPI: 'API',
          schedules: 'Programa',
          campaigns: 'Campañas',
          annoucements: 'Informativos',
          chats: 'Chat Interno',
          financeiro: 'Financiero',
          queueIntegration: 'Integraciones',
          version: 'Versión',
          kanban: 'Kanban',
          prompts: 'Talk.Ai',
          allConnections: 'Admin conexiones',
        },
        appBar: {
          user: {
            profile: 'Perfil',
            logout: 'Cerrar Sesión',
            message: 'Hola',
            messageEnd: 'bienvenido a',
            active: 'Activo hasta',
            goodMorning: 'Hola,',
            myName: 'mi nombre es',
            continuity: 'y te seguiré apoyando.',
            virtualAssistant: 'Asistente Virtual',
            token: 'Token inválido, favor comunicarse con el administrador de la plataforma.',
          },
          message: {
            location: 'Localización',
            contact: 'Contacto',
          },
          notRegister: 'No hay registros',
          refresh: 'Atuaclizar',
        },
      },
      languages: {
        undefined: 'Idioma',
        'es-Mx': 'Español',
        es: 'Español',
        en: 'English',
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Número',
          body: 'Mensaje',
          token: 'Token registrado',
          userId: 'ID usuario/agente',
          queueId: 'ID Fila',
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nombre del archivo',
          media: 'Archivo',
          token: 'Token registrado',
        },
        API: {
          title: 'Documentación para envío de mensajes',
          methods: {
            title: 'Métodos de Envío',
            messagesText: 'Mensajes de Texto',
            messagesMidia: 'Mensajes de Midia',
          },
          instructions: {
            title: 'Instrucciones',
            comments: 'Observaciones Importantes',
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              'El número de envío no debe tener máscara ni caracteres especiales y debe constar de:',
            codeCountry: 'Código del País',
            code: 'Código del Estado',
            number: 'Numero',
          },
          text: {
            title: '1. Mensajes de Texto',
            instructions:
              'A continuación se muestra la lista de información necesaria para enviar mensajes de texto:',
          },
          media: {
            title: '2. Mensagens de Media',
            instructions:
              'A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:',
          },
        },
      },
      notifications: {
        noTickets: 'Sin notificaciones.',
      },
      quickMessages: {
        title: 'Respuestas Rápidas',
        searchPlaceholder: 'Buscar...',
        noAttachment: 'No hay',
        pickerEmpty: 'No hay mensajes rápidos guardados.',
        noTextPreview: '(sin texto)',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta acción no se puede revertir. ¿Continuar?',
        },
        buttons: {
          add: 'Agregar',
          attach: 'Adjuntar Archivo',
          cancel: 'Cancelar',
          edit: 'Editar',
        },
        toasts: {
          success: 'Atajo agregado satisfactoriamente.',
          deleted: 'Atajo excluido satisfactoriamente.',
        },
        dialog: {
          title: 'Mensaje Rápida',
          shortcode: 'Atajo',
          message: 'Respuesta',
          save: 'Guardar',
          cancel: 'Cancelar',
          geral: 'Edición por otros',
          add: 'Agregar',
          edit: 'Editar',
          visao: 'Visible para el equipo',
          sharingSectionTitle: 'Compartir',
          sharingSectionHint:
            'Define quién puede usar esta respuesta en las conversaciones y quién puede editarla.',
          visaoHelper:
            'Activo: otros agentes ven y pueden insertar esta respuesta en las conversaciones.',
          visaoOptionYes: 'Sí, compartir con el equipo',
          visaoOptionNo: 'No, solo yo',
          geralHelper:
            'Activo: cualquier usuario con acceso puede editar el texto y el atajo. Inactivo: solo el creador edita.',
          geralHelperDisabled: 'Disponible cuando la respuesta sea visible para el equipo.',
          geralOptionYes: 'Sí, cualquiera puede editar',
          geralOptionNo: 'No, solo el creador edita',
          subtitle: 'Crea atajos de mensaje para el equipo.',
          insertEmoji: 'Insertar emoji',
          removeAttachment: 'Quitar archivo',
        },
        table: {
          shortcode: 'Atajo',
          message: 'Mensaje',
          actions: 'Acciones',
          mediaName: 'Nombre del Archivo',
          status: 'Status',
          editable: 'Editar',
          viewOnly: 'Solo visualización',
        },
      },
      contactLists: {
        title: 'Listado de Contactos',
        table: {
          name: 'Nombre',
          contacts: 'Contactos',
          actions: 'Acciones',
        },
        buttons: {
          add: 'Nueva lista de contactos',
        },
        dialog: {
          name: 'Nombre',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Agregar',
          add: 'Agregar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        toasts: {
          deleted: 'Registro excluído',
          updated: 'Lista actualizada.',
          created: 'Lista creada.',
        },
      },
      contactListItems: {
        title: 'Contactos',
        searchPlaceholder: 'Búsqueda',
        buttons: {
          add: 'Nuevo',
          lists: 'Listados',
          import: 'Importar',
        },
        dialog: {
          name: 'Nombre',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'Correo electrónico',
          okEdit: 'Editar',
          okAdd: 'Agregar',
          add: 'Agregar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        table: {
          name: 'Nombre',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'Correo electrónico',
          actions: 'Acciones',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta acción no se puede revertir.',
          importMessage: '¿Quieres importar esta plantilla? ',
          importTitlte: 'Importar',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },
      kanban: {
        title: 'Kanban',
        searchPlaceholder: 'Búsqueda',
        subMenus: {
          list: 'Admin',
          tags: 'Lanes',
        },
      },
      campaigns: {
        title: 'Campañas',
        massDispatchTitle: 'Disparo en masa',
        searchPlaceholder: 'Búsqueda',
        subMenus: {
          list: 'Listados',
          listContacts: 'Listados de contatos',
          settings: 'Configuraciones',
        },
        settings: {
          randomInterval: 'Intervalo de disparo aleatorio',
          noBreak: 'Sin Intervalo',
          intervalGapAfter: 'Intervalo mayor después de',
          undefined: 'No definido',
          messages: 'mensajes',
          laggerTriggerRange: 'Intervalo de envío más grande',
          addVar: 'Agregar variable',
          save: 'Guardar',
          close: 'Cerrar',
          add: 'Agregar',
          shortcut: 'Atajo',
          content: 'Contenido',
        },
        buttons: {
          add: 'Nueva campaña',
          addPhrase: 'Nueva campaña por frase',
          contactLists: 'Listado de Contactos',
        },
        table: {
          name: 'Nombre',
          whatsapp: 'Conexión',
          contactList: 'Listado de Contactos',
          option: 'Ninguna',
          disabled: 'Activada',
          enabled: 'Desactivada',
          status: 'Status',
          scheduledAt: 'Programa',
          completedAt: 'Finalizada',
          confirmation: 'Confirmación',
          actions: 'Acciones',
        },
        dialog: {
          new: 'Nueva Campaña',
          update: 'Editar Campaña',
          readonly: 'Solo Visualizar',
          help: 'Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.',
          modalSubtitleNew: 'Configure el envío masivo y vea la vista previa en el móvil.',
          modalSubtitleEdit: 'Ajuste mensajes, público objetivo, conexiones y programación.',
          form: {
            name: 'Nombre',
            message1: 'Mensaje 1',
            message2: 'Mensaje 2',
            message3: 'Mensaje 3',
            message4: 'Mensaje 4',
            message5: 'Mensaje 5',
            confirmationMessage1: 'Mensaje de Confirmación 1',
            confirmationMessage2: 'Mensaje de Confirmación 2',
            confirmationMessage3: 'Mensaje de Confirmación 3',
            confirmationMessage4: 'Mensaje de Confirmación 4',
            confirmationMessage5: 'Mensaje de Confirmación 5',
            messagePlaceholder: 'Contenido del Mensaje',
            whatsapp: 'Conexión',
            status: 'Status',
            scheduledAt: 'Programa',
            confirmation: 'Confirmación',
            contactList: 'Listado de Contacto',
            tagList: 'Contatos por etiqueta',
            targetAudience: 'Público objetivo',
            targetAudienceHelp:
              'Elija una lista de contactos existente o seleccione una etiqueta para generar la lista con los contactos vinculados. Solo se muestran etiquetas que tienen contactos.',
            statusTicket: 'Status del Ticket',
            openTicketStatus: 'Abierto',
            closedTicketStatus: 'Cerrado',
            enabledOpenTicket: 'Activado',
            disabledOpenTicket: 'Desactivado',
            openTicket: 'Abrir ticket',
          },
          buttons: {
            add: 'Agregar',
            edit: 'Actualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Envíos',
            restart: 'Reiniciar Envíos',
            close: 'Cerrar',
            attach: 'Anexar Archivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        toasts: {
          success: 'Acción realizada satisfactoriamente',
          cancel: 'Campaña cancelada',
          restart: 'Campaña reiniciada',
          deleted: 'Registro excluido',
        },
      },
      campaignReport: {
        title: 'Reporte de Campaña',
        back: 'Volver',
        inactive: 'Inactiva',
        scheduled: 'Programada',
        process: 'En Proceso',
        cancelled: 'Cancelada',
        finished: 'Finalizada',
        campaign: 'Campaña',
        validContacts: 'Contactos Válidos',
        confirmationsRequested: 'Confirmaciones Solicitadas',
        confirmations: 'Confirmaciones',
        deliver: 'Entregadas',
        connection: 'Conexión',
        contactLists: 'Listado de Contactos',
        schedule: 'Programados',
        conclusion: 'Conclusión',
      },
      announcements: {
        title: 'Boletines',
        searchPlaceholder: 'Búsqueda',
        active: 'Activo',
        inactive: 'Inactivo',
        buttons: {
          add: 'Nuevo Boletin',
          contactLists: 'Listados de Boletines',
        },
        table: {
          priority: 'Prioridad',
          title: 'Título',
          text: 'Texto',
          mediaName: 'Archivo',
          status: 'Status',
          actions: 'Acciones',
        },
        dialog: {
          edit: 'Editar Boletin',
          add: 'Nuevo Boletin',
          update: 'Editar Boletin',
          readonly: 'Solo visualizar',
          form: {
            priority: 'Prioridad',
            title: 'Título',
            text: 'Texto',
            mediaPath: 'Archivo',
            status: 'Status',
            high: 'Alta',
            medium: 'Mediana',
            low: 'Baja',
            active: 'Activo',
            inactive: 'Inactivo',
          },
          buttons: {
            add: 'Agregar',
            edit: 'Actualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Cerrar',
            attach: 'Anexar Archivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        toasts: {
          success: 'Acción realizada satisfactoriamente',
          deleted: 'Registro excluido',
        },
      },
      campaignsConfig: {
        title: 'Configuraciones de Campañas',
      },
      queues: {
        title: 'Filas',
        table: {
          name: 'Nombre',
          color: 'Color',
          greeting: 'Mensaje de saludo',
          orderQueue: 'Orden de la fila (bot)',
          actions: 'Acciones',
          ID: 'ID',
        },
        buttons: {
          add: 'Agregar fila',
        },
        toasts: {
          success: 'Fila guardada',
          deleted: 'Fila excluida',
        },
        confirmationModal: {
          deleteTitle: 'Eliminar',
          deleteMessage:
            '¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.',
        },
      },
      queue: {
        queueData: 'Datos',
      },
      queueSelect: {
        inputLabel: 'Filas',
        inputLabelRO: 'Filas solo para lectura',
      },
      queueIntegration: {
        title: 'Integraciones',
        table: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nombre',
          projectName: 'Nombre del Proyecto',
          language: 'Idioma',
          lastUpdate: 'Ultima actualización',
          actions: 'Acciones',
        },
        buttons: {
          add: 'Agregar Proyecto',
        },
        searchPlaceholder: 'Buscar...',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            '¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas',
        },
      },
      users: {
        title: 'Usuarios',
        table: {
          status: 'Status',
          name: 'Nombre',
          email: 'Correo Electrónico',
          profile: 'Perfil',
          profiles: {
            admin: 'Administrador',
            user: 'Usuario',
            owner: 'Propietario',
            superAdmin: 'Super Admin',
          },
          startWork: 'Inicio del trabajo',
          endWork: 'Final de trabajo',
          actions: 'Acciones',
          ID: 'ID',
        },
        buttons: {
          add: 'Agregar usuario',
        },
        toasts: {
          deleted: 'Usuario borrado satisfactoriamente.',
        },
        confirmationModal: {
          deleteTitle: 'Borrar',
          deleteMessage:
            'Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.',
        },
      },
      compaies: {
        title: 'Empresas',
        table: {
          ID: 'ID',
          status: 'Activo',
          name: 'Nombre',
          email: 'Correo',
          password: 'Contraseña',
          phone: 'Teléfono',
          plan: 'Plan',
          active: 'Activo',
          numberAttendants: 'Agentes',
          numberConections: 'Conexiones',
          value: 'Valor',
          namePlan: 'Nombre del Plan',
          numberQueues: 'Filas',
          useCampaigns: 'Campañas',
          useSchedules: 'Mensajes programados',
          useInternalChat: 'Chat Interno',
          useFacebook: 'Facebook',
          useInstagram: 'Instagram',
          useWhatsappOfficial: 'Whatsapp Oficial',
          useOpenAi: 'Agentes de IA',
          useTasks: 'Tareas',
          useProducts: 'Productos',
          useIntegrations: 'Integraciones',
          useClients: 'Clientes',
          createdAt: 'F.Creación',
          dueDate: 'Caducidad',
          lastLogin: 'Ult. Login',
          actions: 'Acciones',
          money: 'MXN',
          noPlan: 'Sin plan',
          yes: 'Si',
          no: 'No',
          document: 'CURP/RFC',
          recurrence: 'Recurencia',
          monthly: 'Mensual',
          bimonthly: 'Bimestral',
          quarterly: 'Trimestral',
          semester: 'Semestral',
          yearly: 'Anual',
          clear: 'Limpiar',
          delete: 'Eliminar',
          user: 'Usuario',
          save: 'Guardar',
        },
        buttons: {
          add: 'Agregar empresa',
        },
        toasts: {
          deleted: 'Empresa excluida satisfactoriamente.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.',
        },
      },
      plans: {
        form: {
          name: 'Nombre',
          users: 'Usuarios',
          connections: 'Conexiones',
          campaigns: 'Campañas',
          schedules: 'Programas',
          enabled: 'Activada',
          disabled: 'Desactivada',
          clear: 'Limpiar',
          delete: 'Eliminar',
          save: 'Guardar',
          yes: 'Si',
          no: 'No',
          money: 'MXN',
          planName: 'Nombre del plan',
          visibility: 'Visibilidad',
          recurrence: 'Recurrencia',
          publicOption: 'Público',
          privateOption: 'Privado',
          queues: 'Colas',
          amount: 'Valor',
          allowByok: 'Permitir clave propia (BYOK)',
          allowPlatformCredits: 'Permitir créditos de la plataforma',
          includedCredits: 'Créditos de IA incluidos por período',
        },
        sections: {
          config: 'Configuración',
          limits: 'Límites y valor',
          resources: 'Recursos disponibles',
          ai: 'Inteligencia Artificial',
        },
        grid: {
          empty: 'Ningún plan registrado',
          emptyHelp: 'Haga clic en "Nuevo plan" para comenzar',
          users: 'usuarios',
          connections: 'conexiones',
          queues: 'colas',
          byok: 'BYOK',
          editBtn: 'Editar plan',
          viewBtn: 'Ver plan',
          system: 'Plan del sistema',
          publicTag: 'Público',
          privateTag: 'Privado',
        },
        messages: {
          systemPlanTitle: 'Plan predeterminado del sistema',
          systemPlanWarning:
            'Este plan no se puede editar ni eliminar. Cree un nuevo plan para ofertas personalizadas.',
          addTitle: 'Nuevo plan',
          readonlyTitle: 'Plan (solo lectura)',
          editTitle: 'Editar plan',
          loadError: 'No fue posible cargar la lista de registros',
          systemLocked: 'Este plan es predeterminado del sistema y no se puede modificar.',
          success: '¡Operación realizada con éxito!',
          minCharge: 'Valor mínimo de cobro en BRL no alcanzado. Ajuste el valor del plan.',
          operationError:
            'No fue posible realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente',
          deleteSystemPlan: 'Este plan es predeterminado del sistema y no se puede eliminar.',
          deletePlanDefault: 'El plan predeterminado no se puede eliminar.',
          hasCompanies: 'Este plan tiene empresas vinculadas y no se puede eliminar.',
          hasInvoices: 'Este plan tiene facturas vinculadas y no se puede eliminar.',
          deleteFailed: 'No fue posible realizar la operación',
        },
        modal: {
          deleteTitle: 'Eliminación de Registro',
          deleteConfirm: '¿Realmente desea eliminar este registro?',
          addNew: 'Nuevo plan',
        },
      },
      helps: {
        title: 'Ayuda',
        settings: {
          codeVideo: 'Código del Video',
          description: 'Descripción',
          clear: 'Limpiar',
          delete: 'Eliminar',
          save: 'Guardar',
        },
      },
      schedules: {
        title: 'Programas',
        confirmationModal: {
          deleteTitle: '¿Seguro que quieres excluir este Programa?',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        table: {
          contact: 'Contacto',
          body: 'Mensaje',
          sendAt: 'Fecha del Programa',
          sentAt: 'Fecha de Envío',
          status: 'Status',
          actions: 'Acciones',
        },
        buttons: {
          add: 'Nuevo Programa',
        },
        toasts: {
          deleted: 'Programa eliminado satisfactoriamente.',
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: '¿Seguro que quieres excluir esta Tag?',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        table: {
          name: 'Nombre',
          kanban: 'Kanban',
          color: 'Color',
          tickets: 'Registros Tags',
          contacts: 'Contactos',
          actions: 'Acciones',
        },
        buttons: {
          add: 'Nueva Tag',
        },
        toasts: {
          deleted: 'Tag eliminada satisfactoriamente.',
        },
      },
      tagsKanban: {
        title: 'Lanes',
        laneDefault: 'Abierto(s)',
        confirmationModal: {
          deleteTitle: '¿Seguro que quieres excluir esta Lane?',
          deleteMessage: 'Esta acción no se puede revertir.',
        },
        table: {
          name: 'Nombre',
          color: 'Color',
          tickets: 'Tickets',
          actions: 'Acciones',
        },
        buttons: {
          add: 'Nueva Lane',
        },
        toasts: {
          deleted: 'Lane eliminada satisfactoriamente.',
        },
      },
      files: {
        title: 'Listado de archivos',
        table: {
          name: 'Nombre',
          contacts: 'Contactos',
          actions: 'Acción',
        },
        toasts: {
          deleted: 'Listado borrado satisfactoriamente!',
          deletedAll: 'Todos los listados fueron borrados satisfactoriamente!',
        },
        buttons: {
          add: 'Agregar',
          deleteAll: 'Borrar Todos',
        },
        confirmationModal: {
          deleteTitle: 'Borrar',
          deleteAllTitle: 'Borrar Todos',
          deleteMessage: 'Estás seguro de borrar este listado?',
          deleteAllMessage: 'Estás seguro de borrar todos los listado?',
        },
      },
      settings: {
        success: 'Configuración guardada satisfactoriamente.',
        title: 'Configuración',
        tabs: {
          options: 'Opciones',
          plans: 'Planes',
          helps: 'Ayuda',
        },
        settings: {
          userCreation: {
            name: 'Creación de usuarios',
            options: {
              enabled: 'Habilitado',
              disabled: 'Deshabilitado',
            },
          },
          tabs: {
            options: 'Opciones',
            schedules: 'Horarios',
            plans: 'Planes',
            help: 'Ayuda',
          },
          options: {
            disabled: 'Desactivadas',
            enabled: 'Activadas',
            updating: 'Actualizando...',
            creationCompanyUser: 'Creación de Company/Usuário',
            evaluations: 'Evaluaciones',
            officeScheduling: 'Programar horarios',
            queueManagement: 'Gerenciar por Fila',
            companyManagement: 'Gerenciar por Empresa',
            connectionManagement: 'Gerenciar por Conexión',
            sendGreetingAccepted: 'Enviar saludos al aceptar ticket',
            sendMsgTransfTicket: 'Enviar mensaje de transferencia (departamento/agente)',
            checkMsgIsGroup: 'Ignorar mensajes de Grupos',
            chatBotType: 'Tipo de Bot',
            userRandom: 'Escojer agente aleatorio',
            buttons: 'Botones',
            acceptCallWhatsapp: 'No aceptar llamada en el whatsapp',
            sendSignMessage: 'Permitir agente escoger ENVIAR Firma',
            sendGreetingMessageOneQueues: 'Enviar saludos cuando hay solamente 1 fila',
            sendQueuePosition: 'Enviar mensaje con la posición de la fila',
            sendFarewellWaitingTicket: 'Enviar mensaje de despedida(estado Esperando)',
            acceptAudioMessageContact: 'Aceptar audios de todos',
            enableLGPD: 'Habilitar opción P.P.',
            requiredTag: 'Tag obligatoria para cerrar ticket',
            closeTicketOnTransfer: 'Cerrar ticket al transferir para otra fila',
            DirectTicketsToWallets: 'Mover automaticamente cliente para cartera',
          },
          LGPD: {
            title: 'Politica de Privacidad',
            welcome: 'Mensaje de bienvenida (PP)',
            linkLGPD: 'Link de la política de privacidad',
            obfuscateMessageDelete: 'Ofuscar mensaje borrada',
            alwaysConsent: 'Requerir siempre el consentimiento',
            obfuscatePhoneUser: 'Ofuscar número de telefono para usuarios',
            enabled: 'Activado',
            disabled: 'Desactivado',
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Asignado a:',
          dialogRatingTitle: '¿Quieres dejar un mensaje de evaluación para el cliente?',
          dialogClosingTitle: 'Finalizando la atención al cliente!',
          dialogRatingCancel: 'Cerrar CON Mensaje de Despedida',
          dialogRatingSuccess: 'Cerrar y Enviar Evaluación',
          dialogRatingWithoutFarewellMsg: 'Cerrar SIN Mensaje de Despedida',
          ratingTitle: 'Elegir menú de evaluación',
          notMessage: 'No hay mensaje seleccionado',
          buttons: {
            return: 'Devolver',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceptar',
            rating: 'Enviar Evaluación',
            enableIntegration: 'Activar/Desactivar integración',
            logTicket: 'Logs del Ticket',
            requiredTag: 'Opps! Debes asignar una tag antes de cerrar el ticket.',
          },
        },
        reactionPicker: {
          moreEmojis: 'Más emojis',
        },
        reactionDetail: {
          titleOne: '1 reacción',
          titleMany: '{{count}} reacciones',
          you: 'Tú',
          clickToRemove: 'Clic para quitar',
          removeMyReaction: 'Quitar mi reacción',
          removeSessionFooterHint:
            'Use el enlace de abajo para quitar la reacción enviada por esta conexión de WhatsApp en el panel.',
          badgeHint: 'Ver reacciones',
        },
      },
      messagesInput: {
        placeholderPrivateMessage: 'Entre como un mensaje o con / para respuestas rápidas',
        placeholderOpen: 'Entre como un mensaje o con / para respuestas rápidas',
        placeholderClosed: 'Vuelva a abrir o acepte este ticket para enviar un mensaje.',
        signMessage: 'Firmar',
        privateMessage: 'Mensaje Privada',
      },
      contactDrawer: {
        header: 'Detalles del contacto',
        buttons: {
          edit: 'Editar contacto',
          block: 'Bloquear',
          unblock: 'Desbloquear',
        },
        extraInfo: 'Otras informaciones',
      },
      messageVariablesPicker: {
        label: 'Variables disponibles',
        vars: {
          contactFirstName: 'Primer Nombre',
          contactName: 'Nombre',
          user: 'Agente',
          greeting: 'Saludos',
          protocolNumber: 'Protocolo',
          date: 'Fecha',
          hour: 'Hora',
          ticket_id: 'Nº del Ticket',
          queue: 'Sector',
          connection: 'Conexión',
          invoiceDueDate: 'Vencimiento de la factura',
          invoiceValue: 'Valor de la factura',
        },
      },
      ticketOptionsMenu: {
        schedule: 'Programa',
        delete: 'Borrar',
        transfer: 'Transferir',
        registerAppointment: 'Observaciones del Contacto',
        resolveWithNoFarewell: 'Cerrar sin despedida',
        acceptAudioMessage: '¿Aceptar audios del contacto?',
        appointmentsModal: {
          title: 'Observaciones del Contacto',
          textarea: 'Observación',
          placeholder: 'Agregue aqui la información',
        },
        confirmationModal: {
          title: '¿Borrar ticket #',
          titleFrom: 'del contacto ',
          message:
            '¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.',
        },
        buttons: {
          delete: 'Borrar',
          cancel: 'Cancelar',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Confirmar',
          cancel: 'Cancelar',
        },
      },
      messageInput: {
        tooltip: {
          signature: 'Activar/Desactivar firma',
          privateMessage: 'Activar/Desactivar mensaje privado',
          meet: 'Enviar link para videollamada',
        },
        type: {
          attachFile: 'Adjuntar archivo',
          imageVideo: 'Fotos y videos',
          cam: 'Cámara',
          document: 'Documento',
          contact: 'Contacto',
          meet: 'Link Jitsi Meet',
          privateMessage: 'Mensaje privado',
          scheduleMessage: 'Programación de mensaje',
          moreOptions: 'Más opciones',
          moreOptionsDetail: 'Más opciones (botones, listas, etc.)',
          quickMessages: 'Mensajes rápidos',
          signature: 'Firma (nombre del agente)',
          emojis: 'Emojis',
        },
      },
      messageOptionsMenu: {
        delete: 'Borrar',
        reply: 'Responder',
        edit: 'Editar',
        forward: 'Enviar',
        toForward: 'Enviar',
        talkTo: 'Platicar Con',
        copyMessage: 'Copiar mensaje',
        copySuccess: '¡Mensaje copiado!',
        copyNoText: 'Este mensaje no tiene texto para copiar.',
        confirmationModal: {
          title: '¿Borrar mensaje?',
          message: 'Esta acción no puede ser revertida.',
        },
      },
      invoices: {
        table: {
          invoices: 'Facturas',
          details: 'Detalles',
          users: 'Usuarios',
          connections: 'Conexiones',
          queue: 'Filas',
          value: 'Valor',
          expirationDate: 'Fecha Venc.',
          action: 'Acción',
        },
      },
      import: {
        page: {
          title: 'Importaciones',
          subtitle:
            'Seguimiento de importaciones de historial WhatsApp y Meta (Facebook/Instagram)',
        },
        buttons: {
          refresh: 'Actualizar',
          startMeta: 'Importar historial (Meta)',
          backToConnections: 'Volver a Conexiones',
        },
        emptyState: 'Ninguna importación encontrada',
        toasts: {
          started: 'Import iniciado',
          finished: 'Import finalizado',
        },
        metaModal: {
          title: 'Importar historial (Meta)',
          hint: 'Si el token está vacío, el backend usa el token guardado en la conexión.',
          selectConnection: 'Seleccione la conexión',
          selectConnectionRequired: 'Seleccione una conexión',
          loadingConnections: 'Cargando conexiones...',
          noConnections: 'Ninguna conexión Meta encontrada',
          pageIdRequired: 'Page ID es obligatorio',
          dateStart: 'Fecha inicio',
          dateEnd: 'Fecha fin',
        },
        banner: {
          importing: 'Importando historial…',
          viewDetails: 'Ver detalles',
        },
        tooltips: {
          whatsappAuto: 'WhatsApp importa automáticamente tras conectar',
          metaRateLimit: 'Meta depende de permisos y límite de tasa.',
        },
      },
      toastErrors: {
        generic: 'No fue posible completar la operación. Inténtelo de nuevo.',
        network: 'Fallo de conexión. Verifique su internet e inténtelo de nuevo.',
        timeout: 'La solicitud tardó demasiado. Inténtelo de nuevo.',
        serverError: 'Error del servidor ({{status}}). Inténtelo de nuevo en unos instantes.',
        notFound: 'Recurso no encontrado. Verifique los datos e inténtelo de nuevo.',
        forbidden: 'No tiene permiso para realizar esta acción.',
        noPermissionToCreateContact:
          'No tiene permiso para crear contactos. Solicite al administrador que inicie un servicio con este contacto.',
        httpError: 'No fue posible completar la operación (error {{status}}). Inténtelo de nuevo.',
        noPagePermission: '¡Esta empresa no tiene permiso para acceder a esta página!',
        whatsappIdInput: 'Ingrese el ID de WhatsApp.',
        fileTooLarge5mb: '¡El archivo es muy grande! 5MB máximo',
        selectQueue: 'Seleccione una cola',
        selectFlow: 'Seleccione un flujo',
        ticketIdInput: 'Ingrese el ID del Ticket.',
        enterMessageText: 'Escriba el texto del mensaje',
        addAtLeastOneTag: 'Agregue al menos una etiqueta',
        selectKanbanTag: 'Seleccione una etiqueta kanban',
        invoiceIdInput: 'Ingrese el ID de la Factura.',
        userIdInput: 'Ingrese el ID del Usuario.',
        couldNotLoadRecords: 'No fue posible cargar la lista de registros',
        invalidCpfCnpj: 'CPF/CNPJ inválido. Verifique el número ingresado.',
        errorUpdatingQueue: 'Error al actualizar la cola.',
        fileTooLarge20mb: '¡El archivo es muy grande! 20MB máximo',
        errorLoadingData: 'Error al cargar datos',
        enterScheduleDateTime: 'Ingrese la fecha y hora de la cita.',
        dateTimeMustBeFuture: 'La fecha y hora deben ser en el futuro.',
        delayMin1Minute: 'El retraso debe ser de al menos 1 minuto.',
        couldNotPerformOperation: 'No fue posible realizar la operación',
        invalidPrimaryColor: 'Color primario inválido. Use el formato HEX (#RGB o #RRGGBB).',
        invalidColors: 'Hay colores inválidos. Use el formato HEX (#RGB o #RRGGBB).',
        jsonInvalidQueueIds: 'JSON inválido en queueIds',
        tagIdToSearch: 'Ingrese el ID de la Etiqueta para buscar un registro.',
        companyNotIdentified:
          'Empresa no identificada. Inicie sesión nuevamente o seleccione una empresa.',
        sourceAlreadyExists: 'Este origen ya existe.',
        selectAtLeastOneTicket: 'Seleccione al menos un ticket',
        selectTagInContacts: 'Seleccione la etiqueta (en los contactos)',
        enterTokenBeforeDownload: 'Ingrese el token antes de descargar la colección.',
        invalidFlow: 'Flujo inválido.',
        errorFetchingZip: 'Error al consultar el código postal. Inténtelo de nuevo.',
        nameRequiredArticle: 'El nombre es obligatorio.',
        invalidEmail: 'Correo inválido.',
        invalidCpf: 'CPF inválido.',
        invalidCnpj: 'CNPJ inválido.',
        enterNewPassword: 'Ingrese la nueva contraseña.',
        passwordsDoNotMatch: 'Las contraseñas no coinciden.',
        companyCannotBeDeleted: 'Esta empresa no puede ser eliminada.',
        couldNotSaveValue: 'No fue posible guardar el valor.',
        fileExceeds20mb: 'El archivo excede el límite de 20 MB',
        selectClient: 'Seleccione un cliente.',
        enterInvoiceDescription: 'Ingrese la descripción de la factura.',
        enterInvoiceValue: 'Ingrese el monto de la factura.',
        enterDueDate: 'Ingrese la fecha de vencimiento.',
        selectReferenceItem: 'Seleccione el ítem relacionado o limpie el tipo de referencia.',
        errorSendingFile: 'Error al enviar el archivo. Inténtelo de nuevo.',
        selectFile: '¡Seleccione un archivo!',
        selectKanbanTagAlt: 'Seleccione una etiqueta del Kanban',
        selectTag: 'Seleccione una etiqueta',
        invalidHeadersJson: 'JSON de headers inválido',
        invalidBodyJson: 'JSON de body inválido',
        errorTestingApi: 'Error al probar la API',
        enterRequestUrl: 'Ingrese la URL de la solicitud',
        addValidCondition: 'Agregue al menos una condición válida',
        selectPipeline: 'Seleccione un pipeline',
        selectStage: 'Seleccione una etapa',
        enterTitle: 'Ingrese un título',
        selectTargetStage: 'Seleccione la etapa destino',
        enterLossReason: 'Ingrese el motivo de la pérdida',
        errorStartingAuth: 'Error al iniciar la autenticación',
        enterSpreadsheetId: 'Ingrese el ID de la planilla',
        errorTestingConnection: 'Error al probar la conexión',
        selectSpreadsheet: 'Seleccione una planilla',
        enterSheetName: 'Ingrese el nombre de la pestaña',
        addDataField: 'Agregue al menos un campo de datos',
        enterColumnAndValue: 'Ingrese la columna y el valor para buscar',
        enterIntervalValue: 'Agregue el valor del intervalo (mínimo 1 segundo)',
        percentAboveZero: 'Defina un porcentaje superior a 0%',
        percentMax100: 'El porcentaje máximo es 100%',
        errorFetchingQueues: 'Error al buscar colas',
        selectWhatsappConnection: 'Seleccione una conexión de WhatsApp',
        enterMessage: 'Escriba el mensaje',
        invalidNumber:
          'Número inválido. Use código de país + código de área + número (ej: 5585999999999)',
        errorReadingMessage: 'Error al leer el mensaje. Cierre y vuelva a abrir el modal.',
        emptyMessageFields: '¡Los campos del mensaje están vacíos!',
        errorReadingInterval: 'Error al leer el intervalo. Cierre y vuelva a abrir el modal.',
        intervalRange: '¡El intervalo no puede ser 0 ni mayor que 120!',
        deleteEmptyCards: 'Elimine las tarjetas vacías (Imagen, Archivo, Audio y Video)',
        verifyTokenEmpty: 'El verify token no puede estar vacío.',
        folderNameRequired: 'El nombre de la carpeta es obligatorio.',
        enterPaymentValue: 'Ingrese el monto del pago.',
        tokenRequiredWhenProviderActive: 'El token es obligatorio cuando el proveedor está activo.',
        couldNotRemoveAccess: 'No fue posible eliminar el acceso',
        minChargeNotReached:
          'No se alcanzó el monto mínimo de cobro en BRL. Ajuste el precio del plan.',
        defaultPlanCannotBeDeleted: 'El plan predeterminado no puede ser eliminado.',
        planHasCompanies: 'Este plan tiene empresas vinculadas y no puede ser eliminado.',
        planHasInvoices: 'Este plan tiene facturas vinculadas y no puede ser eliminado.',
        couldNotLoadServices: 'No fue posible cargar la lista de servicios',
        enterProfessionalName: 'Ingrese el nombre del profesional',
        errorSavingProfessional: 'Error al guardar el profesional',
        couldNotSendFile: 'No fue posible enviar el archivo.',
        enterTitleAndLink: 'Ingrese el título y el enlace.',
        enterValidLink: 'Ingrese un enlace válido (https://...).',
        errorSavingService: 'Error al guardar el servicio',
        errorUploadingIcon: 'Error al subir el ícono.',
        onlyImages: 'Envíe solo imágenes (PNG, JPG, WebP o ICO).',
        noAccessPermission: '¡Sin permiso para acceder!',
        onlyP12Files: '¡Use solo archivos en formato p12!',
        errorSendingCertificate: 'Error al enviar el certificado. Inténtelo de nuevo.',
        errorSavingTheme: 'Error al guardar el tema.',
        errorSavingColors: 'Error al guardar la personalización de colores.',
        errorSavingEmailFooter: 'Error al guardar la configuración del pie de correo.',
        serverResponseNoFilename: 'Respuesta del servidor sin nombre de archivo.',
        errorUploadingImage: 'Error al subir la imagen.',
        couldNotSaveBanner: 'No fue posible guardar el banner',
        couldNotLoadBanners: 'No fue posible cargar los banners',
        couldNotRemoveBanner: 'No fue posible eliminar el banner',
        invalidValue: 'Valor inválido.',
        urlNotConfigured: 'URL no configurada.',
        errorLinkingClient: 'Error al vincular el cliente.',
        couldNotSaveAdditionalInfo: 'No fue posible guardar la información adicional.',
        couldNotUpdateChatbot: 'No fue posible actualizar el chatbot.',
        couldNotUpdateAudioPermission: 'No fue posible actualizar el permiso de audio.',
        couldNotChangeContactStatus: 'No fue posible cambiar el estado del contacto.',
        titleRequired: 'El título es obligatorio',
        videoUrlRequired: 'La URL del video es obligatoria',
        descriptionMax300: 'La descripción debe tener como máximo 300 caracteres',
        errorAccessingMic: 'Error al acceder al micrófono. Verifique los permisos.',
        recordingTooShort: 'Grabación muy corta. Grabe por más tiempo.',
        errorSendingAudio: 'Error al enviar el audio. Inténtelo de nuevo.',
        errorProcessingAudio: 'Error al procesar el audio.',
        errorCancellingRecording: 'Error al cancelar la grabación.',
        invalidContactForSend: 'Contacto inválido para el envío. Verifique nombre y número.',
        errorUpdatingHubToken: 'Hubo un error al intentar actualizar el token del Hub.',
        clientIdToSearch: 'Ingrese el ID del Cliente para buscar un registro.',
        nameRequiredDot: 'El nombre es obligatorio.',
        contactIdToSearch: 'Ingrese el ID del Contacto para buscar un registro.',
        clientValueDueRequired: 'Cliente, monto y fecha de vencimiento son obligatorios.',
        invoiceIdRequired: 'El ID de la factura es obligatorio.',
        queueIdToSearch: 'Ingrese el ID de la Cola para buscar un registro.',
        dealIdToSearch: 'Ingrese el ID del Negocio para buscar un registro.',
        productIdToSearch: 'Ingrese el ID del Producto para buscar un registro.',
        serviceIdToSearch: 'Ingrese el ID del Servicio para buscar un registro.',
        taskIdToSearch: 'Ingrese el ID de la Tarea para buscar.',
        jsonInvalidTagIds: 'JSON inválido en tagIds',
        userOrQueueToTransfer: 'Ingrese el ID de Usuario o el ID de Cola para transferir.',
        jsonInvalidServiceIds: 'JSON inválido en serviceIds',
        userIdToSearch: 'Ingrese el ID del Usuario para buscar.',
        userIdAndServiceIds: 'Ingrese el ID de Usuario y serviceIds.',
        userIdAndDateTime: 'Ingrese el ID de Usuario y Fecha/Hora.',
        userIdAppointmentStatus: 'Ingrese el ID de Usuario, ID de Cita y Estado.',
        couldNotGetPaymentLink: 'No fue posible recuperar el enlace de pago.',
        couldNotCloseTickets: 'No fue posible cerrar los tickets. Inténtelo de nuevo.',
        mustAcceptTerms: 'Debe aceptar los términos para continuar.',
        enterPipelineName: 'Ingrese el nombre del embudo',
        onlyOneWonStage: 'Solo 1 etapa puede marcarse como Ganada',
        onlyOneLostStage: 'Solo 1 etapa puede marcarse como Perdida',
        exportedFileEmpty: 'Error: El archivo exportado está vacío',
        selectFileToImport: 'Seleccione un archivo para importar',
        fileMustBeJson: 'El archivo debe ser de tipo JSON',
        configureQueueNodes:
          'Configure la cola en todos los nodos "Dirigir a Cola" antes de guardar.',
        emailNotFound: 'Correo no encontrado',
        saveIntegrationBeforeMapping: 'Guarde la integración antes de mapear campos.',
        invalidTestJson: 'JSON de prueba inválido.',
        selectTicketStatus: 'Seleccione al menos un estado de ticket',
        selectWeekday: 'Seleccione al menos un día de la semana',
        profileNotFound: 'Perfil no encontrado.',
        imageMax1mb: 'La imagen debe tener como máximo 1 MB',
        nameRequired: 'El nombre es obligatorio',
        selectUser: 'Seleccione un usuario',
        couldNotGetGoogleLink: 'No fue posible obtener el enlace de conexión con Google.',
        allowPopups: 'Permita ventanas emergentes en este sitio para conectar Google Calendar.',
      },
      toastSuccess: {
        operation: '¡Operación realizada con éxito!',
        operationUpdated: 'Operación actualizada con éxito.',
        saved: 'Guardado con éxito.',
        settingsSaved: '¡Configuraciones guardadas!',
        settingsSavedSuccess: '¡Configuraciones guardadas con éxito!',
        settingsReset: '¡Configuraciones restablecidas con éxito!',
        configSaved: 'Configuración guardada con éxito.',
        configRemoved: 'Configuración eliminada.',
        copied: '¡Copiado!',
        linkCopied: '¡Enlace copiado!',
        redirectUriCopied: '¡Redirect URI copiada!',
        webhookUrlCopied: '¡URL del webhook copiada!',
        clickSaveToApply: 'Haga clic en guardar para registrar los cambios.',
        exported: '¡Datos exportados con éxito!',
        testSuccess: '¡Prueba realizada con éxito!',
        connectionTested: '¡Conexión probada con éxito!',
        fileSent: '¡Archivo enviado con éxito!',
        filesSent: 'Archivos enviados con éxito.',
        fileRemoved: 'Archivo eliminado con éxito.',
        fileUploaded: 'Archivo enviado.',
        fileAdded: '¡Archivo agregado con éxito!',
        contentAdded: '¡Contenido agregado con éxito!',
        audioAdded: '¡Audio agregado con éxito!',
        videoAdded: '¡Video agregado con éxito!',
        videoCreated: '¡Video creado con éxito!',
        videoUpdated: '¡Video actualizado con éxito!',
        videoRemoved: '¡Video eliminado con éxito!',
        folderCreated: '¡Carpeta creada con éxito!',
        folderUpdated: '¡Carpeta actualizada con éxito!',
        folderDeleted: '¡Carpeta eliminada con éxito!',
        knowledgeFileAdded: '¡Archivo agregado a la base de conocimiento!',
        knowledgeLinkAdded: '¡Enlace agregado a la base de conocimiento!',
        appointmentCreated: 'Cita creada con éxito.',
        appointmentUpdated: 'Cita actualizada con éxito.',
        appointmentDeleted: 'Cita eliminada con éxito.',
        statusUpdated: 'Estado actualizado.',
        scheduleCreated: 'Agenda creada con éxito.',
        scheduleUpdated: 'Agenda actualizada con éxito.',
        scheduleDeleted: 'Agenda eliminada con éxito.',
        googleCalendarLinked: '¡Agenda vinculada a su Google Calendar con éxito!',
        googleCalendarUnlinked: 'Google Calendar desvinculado de la agenda.',
        googleCalendarDisconnected: 'Google Calendar desconectado con éxito.',
        taskCreated: '¡Tarea creada con éxito!',
        taskUpdated: '¡Tarea actualizada con éxito!',
        taskRemoved: 'Tarea eliminada.',
        taskRestored: 'Tarea restaurada.',
        taskTrashed: 'Tarea enviada a la papelera.',
        taskDeletedPermanently: 'Tarea eliminada permanentemente.',
        opportunityRestored: '"{{title}}" restaurada con éxito.',
        opportunityDeletedPermanently: 'Oportunidad eliminada permanentemente.',
        companyCreated: '¡Empresa registrada con éxito!',
        planAccessRemoved: 'Acceso eliminado del plan.',
        appUpdated: 'App actualizada con éxito.',
        appActivated: '{{app}} activada.',
        appActivatedSuccess: '¡{{app}} activada con éxito!',
        appActivatedInvoicePaid: '{{app}} activada — la factura ya estaba pagada.',
        appDeactivated: '{{app}} desactivada.',
        appRequestCancelled: 'Solicitud de {{app}} cancelada.',
        paymentConfirmed: 'Pago confirmado.',
        appPaymentConfirmed: 'Pago confirmado — {{app}} liberada.',
        redirectingToPayment: 'Redirigiendo al pago...',
        licenseRenewed: '¡Su licencia ha sido renovada hasta {{date}}!',
        openPaymentTab: 'Abra la pestaña para completar el pago.',
        aiCreditsReversed: 'Créditos revertidos con éxito.',
        aiCreditsRequestSent: 'Solicitud enviada. Espere la aprobación del administrador.',
        aiCreditsRequestRejected: 'Solicitud rechazada.',
        aiCreditsRequestCancelled: 'Solicitud cancelada.',
        aiCreditsRenewed: '¡Créditos de IA renovados con éxito!',
        aiCreditsAddedToAccount: 'Créditos agregados a su cuenta.',
        aiCreditsAdded: '{{credits}} créditos agregados a {{company}}.',
        apiKeySaved: 'Clave {{label}} guardada con éxito.',
        apiKeyRemoved: 'Clave {{label}} eliminada.',
        markupUpdated: 'Markup actualizado.',
        modelCreated: 'Modelo registrado.',
        modelUpdated: 'Modelo actualizado.',
        modelDisabled: 'Modelo desactivado.',
        metaCredentialsSaved: 'Credenciales de Facebook/Meta guardadas con éxito.',
        googleCredentialsSaved: 'Credenciales de Google guardadas con éxito.',
        smtpSaved: 'Configuraciones SMTP guardadas con éxito.',
        openaiKeySaved: 'Clave OpenAI guardada con éxito.',
        whatsappOfficialSaved: 'Configuración de WhatsApp Oficial guardada con éxito.',
        pixEfiSaved: 'Configuración Pix Efí guardada con éxito.',
        googleSheetsAuthenticated: '¡Autenticado con Google Sheets!',
        integrationCreated: 'Integración creada.',
        integrationUpdated: 'Integración actualizada.',
        integrationRemoved: 'Integración eliminada.',
        mappingSaved: 'Mapeo guardado.',
        baseUrlSaved: '¡Copiado y URL base guardada en el backend!',
        whatsappConnected: '¡WhatsApp conectado con éxito!',
        contactBlocked: 'Contacto bloqueado.',
        contactUnblocked: 'Contacto desbloqueado.',
        contactsImported: 'Contactos importados de la conexión.',
        spreadsheetImported: 'Planilla importada.',
        noteAdded: '¡Observación agregada con éxito!',
        noteDeleted: '¡Observación eliminada con éxito!',
        clientCreated: '¡Cliente creado con éxito!',
        clientUpdated: '¡Cliente actualizado con éxito!',
        ticketValueUpdated: '¡Valor del ticket actualizado!',
        queueUpdated: '¡Cola actualizada!',
        allTicketsClosed: 'Todos los tickets {{status}} fueron cerrados.',
        chatbotEnabled: 'Chatbot habilitado.',
        chatbotDisabled: 'Chatbot deshabilitado.',
        contactActivated: 'Contacto activado con éxito.',
        contactDeactivated: 'Contacto desactivado.',
        pipelineCreated: '¡Embudo creado!',
        pipelineSaved: '¡Embudo guardado!',
        pipelineDeleted: '¡Embudo eliminado!',
        crmFieldCreated: 'Campo creado.',
        crmFieldUpdated: 'Campo actualizado.',
        crmFieldRemoved: 'Campo eliminado.',
        crmSourceCreated: '¡Origen creado!',
        crmSourceRemoved: 'Origen eliminado.',
        automationCreated: 'Automatización creada.',
        automationUpdated: 'Automatización actualizada.',
        automationRemoved: 'Automatización eliminada.',
        triggerCreated: 'Disparo creado con éxito.',
        triggerUpdated: 'Disparo actualizado con éxito.',
        triggerRemoved: 'Disparo eliminado.',
        productSaved: 'Producto guardado con éxito.',
        productCreated: 'Producto creado con éxito.',
        productUpdated: 'Producto actualizado.',
        productDeleted: 'Producto eliminado.',
        variantCreated: 'Variante creada.',
        variantUpdated: 'Variante actualizada.',
        variantDeleted: 'Variante eliminada.',
        variantsGenerated: 'Variaciones generadas.',
        categoryCreated: 'Categoría creada.',
        categoryUpdated: 'Categoría actualizada.',
        categoryDeleted: 'Categoría eliminada.',
        attributeCreated: 'Atributo creado.',
        attributeUpdated: 'Atributo actualizado.',
        attributeDeleted: 'Atributo eliminado.',
        optionDeleted: 'Opción eliminada.',
        professionalCreated: '¡Profesional creado con éxito!',
        professionalUpdated: '¡Profesional actualizado con éxito!',
        professionalRemoved: '¡Profesional eliminado con éxito!',
        serviceCreated: '¡Servicio creado con éxito!',
        serviceRemoved: '¡Servicio eliminado con éxito!',
        serviceUpdated: '¡Servicio actualizado con éxito!',
        queueHoursSet: '¡Horarios configurados con éxito!',
        queueHoursUpdated: '¡Horarios actualizados con éxito!',
        phraseCreated: '¡Frase creada con éxito!',
        phraseUpdated: '¡Frase modificada con éxito!',
        phraseDeleted: 'Frase eliminada.',
        campaignDeleted: 'Campaña eliminada.',
        flowCreated: 'Flujo creado con éxito.',
        flowUpdated: 'Flujo actualizado con éxito.',
        flowSaved: 'Flujo guardado con éxito.',
        flowDeleted: 'Flujo eliminado con éxito.',
        flowDuplicated: 'Flujo duplicado con éxito.',
        flowExported: 'Flujo exportado con éxito.',
        flowImported: '¡Flujo "{{name}}" importado con éxito!',
        defaultFlowsUpdated: 'Flujos predeterminados actualizados.',
        followUpScheduled: 'Follow-up programado.',
        followUpCancelled: 'Follow-up cancelado.',
        followUpCreated: 'Follow-up creado con éxito.',
        followUpByTagScheduled: 'Follow-up por etiqueta programado.',
        followUpsByTagScheduled: '{{count}} follow-ups por etiqueta programados.',
        followUpsCreated: '{{count}} follow-ups creados con éxito.',
        allTicketFollowUpsCancelled: 'Todos los follow-ups del ticket fueron cancelados.',
        processingTriggered: 'Procesamiento activado.',
        noResponseRuleCreated: 'Regla de tiempo sin respuesta creada.',
        noResponseRuleUpdated: 'Regla de tiempo sin respuesta actualizada.',
        recurringRuleCreated: 'Regla de follow-up recurrente creada.',
        recurringRuleUpdated: 'Regla de follow-up recurrente actualizada.',
        tagContactsRuleCreated: 'Regla por etiqueta (contactos) creada.',
        ruleDeleted: 'Regla eliminada.',
        bannerCreated: '¡Banner creado con éxito!',
        bannerUpdated: '¡Banner actualizado con éxito!',
        bannerRemoved: '¡Banner eliminado con éxito!',
        colorsSaved: 'Colores de personalización guardados con éxito.',
        themeSaved:
          'Todo el tema fue guardado: Menú, Botones y Enlaces, Tipografía y color primario (cuando se modifican).',
        emailFooterSaved: 'Configuraciones del pie de correo guardadas con éxito.',
        tabTitleUpdated: 'Título de la pestaña actualizado con éxito.',
        tabIconUpdated: 'Ícono de la pestaña actualizado con éxito.',
        pwaIconUpdated: 'Ícono PWA actualizado. El backend generó los tamaños predeterminados.',
        invoiceCopyGenerated: 'Segunda vía generada con éxito.',
        paymentRegistered: 'Pago registrado con éxito.',
        paymentRemoved: 'Pago eliminado.',
        invoiceDeleted: 'Factura eliminada con éxito.',
        subscriptionCancelled: 'Suscripción cancelada.',
        subscriptionReactivated: 'Suscripción reactivada.',
        kanbanCreated: '¡Kanban creado con éxito!',
        kanbanTagDeleted: 'Etiqueta Kanban eliminada con éxito.',
        reasonSaved: 'Motivo guardado.',
        reasonCreated: '¡Motivo creado!',
        reasonRemoved: 'Motivo eliminado.',
        tokenGenerated: '¡Token generado con éxito!',
        tokenCopied: '¡Token copiado al portapapeles!',
        tokenRemoved: '¡Token eliminado con éxito!',
        messageSent: 'Mensaje enviado con éxito.',
        notificationSent: '¡Notificación enviada!',
        notificationRemoved: 'Notificación eliminada.',
        notificationsEnabled:
          'Notificaciones activadas. Recibirá avisos de nuevos leads y mensajes.',
        iaWorkflowDeleted: '¡Workflow de IA eliminado con éxito!',
        profileUpdated: '¡Perfil actualizado con éxito!',
        quickMessageDeleted: 'Respuesta rápida eliminada con éxito.',
        importStarted: 'Importación iniciada.',
        queueDeleted: 'Cola eliminada con éxito.',
        emailSent: 'Correo enviado con éxito.',
        newCodeSent: 'Nuevo código enviado a su correo.',
        passwordChanged: 'Contraseña cambiada con éxito.',
      },
      toastInfo: {
        cepNotFound: 'Código postal no encontrado.',
        noChangesToSave: 'No hay cambios para guardar.',
        noColorChangesToSave: 'No hay cambios de colores para guardar.',
        googleAuthWaiting: 'Aún esperando la autenticación de Google.',
        completeAuthInWindow: 'Complete la autenticación en la ventana abierta.',
        paymentNotConfirmedYet:
          'El pago aún no consta como confirmado. Espere e inténtelo de nuevo.',
        qrNotAvailableYet: 'Código QR aún no disponible.',
        chargeRequested: 'Cobro solicitado. Verifique sus facturas en instantes.',
        notificationsDisabled: 'Notificaciones desactivadas.',
        preparingFlowExport: 'Preparando la exportación del flujo...',
        importingFlow: 'Importando flujo, por favor espere...',
        addAtLeastOneMapping: 'Agregue al menos un mapeo.',
        couldNotVerifyConnections: 'No fue posible verificar las conexiones. Inténtelo de nuevo.',
        themeApplied:
          'Tema aplicado al borrador (incluido el color primario). Use «Guardar todo el tema» arriba o guarde cada sección abajo para registrar en el servidor.',
      },
      toastWarning: {
        invalidCreditValue: 'Ingrese un valor válido de créditos.',
        apiKeyRequired: 'Ingrese la clave de la API {{label}}.',
        modelIdRequired: 'Ingrese el identificador del modelo.',
        providerRequired: 'Seleccione el proveedor.',
        modelPricesRequired: 'Ingrese los precios de input y output (USD por 1M tokens).',
        defaultPlanCannotEdit: 'Este plan es predeterminado del sistema y no puede modificarse.',
        defaultPlanCannotDelete: 'Este plan es predeterminado del sistema y no puede eliminarse.',
        configureAtLeastOneField: 'Configure al menos un campo para actualizar.',
        nameMinLength: 'Ingrese un nombre con al menos 2 caracteres.',
        automationNameRequired: 'Ingrese un nombre para la automatización.',
        statusRequired: 'Seleccione el estado.',
        addAtLeastOneAction: 'Agregue al menos una acción.',
        categoryNameRequired: 'Ingrese el nombre de la categoría.',
        optionNameRequired: 'Complete el nombre de la opción.',
        abbreviationRequired: 'Complete la sigla.',
        attributeNameRequired: 'Ingrese el nombre del atributo.',
        productNameRequired: 'Complete el nombre del producto.',
        productNameRequiredToContinue: 'Complete el nombre del producto para continuar.',
        invoiceCopyFailed: 'No fue posible generar la segunda vía.',
        chargeFailed: 'No fue posible generar el cobro.',
      },
      apiDocs: {
        clientsLoaded: '¡Clientes cargados!',
        clientLoaded: '¡Cliente cargado!',
        clientCreated: '¡Cliente creado con éxito!',
        clientUpdated: '¡Cliente actualizado con éxito!',
        clientRemoved: '¡Cliente eliminado!',
        queuesLoaded: '¡Colas cargadas!',
        queueLoaded: '¡Cola cargada!',
        queueCreated: '¡Cola creada con éxito!',
        queueUpdated: '¡Cola actualizada con éxito!',
        queueRemoved: '¡Cola eliminada!',
        connectionsLoaded: '¡Conexiones cargadas!',
        connectionLoaded: '¡Conexión cargada!',
        statusLoaded: '¡Estado cargado!',
        connectionUpdated: '¡Conexión actualizada!',
        connectionRestarting: '¡Conexión reiniciando!',
        connectionDisconnected: '¡Conexión desconectada!',
        connectionCreated: '¡Conexión creada! Espere el código QR.',
        qrAvailable: '¡Código QR disponible!',
        connectionRemoved: '¡Conexión eliminada!',
        servicesLoaded: '¡Servicios cargados!',
        serviceLoaded: '¡Servicio cargado!',
        serviceRemoved: '¡Servicio eliminado!',
        tagsLoaded: '¡Etiquetas cargadas!',
        tagLoaded: '¡Etiqueta cargada!',
        tagCreated: '¡Etiqueta creada con éxito!',
        tagUpdated: '¡Etiqueta actualizada con éxito!',
        tagRemoved: '¡Etiqueta eliminada!',
        tasksLoaded: '¡Tareas cargadas!',
        taskLoaded: '¡Tarea cargada!',
        taskCreated: '¡Tarea creada con éxito!',
        taskUpdated: '¡Tarea actualizada con éxito!',
        taskRemoved: '¡Tarea eliminada!',
        contactsLoaded: '¡Contactos cargados!',
        contactLoaded: '¡Contacto cargado!',
        contactCreated: '¡Contacto creado con éxito!',
        contactUpdated: '¡Contacto actualizado con éxito!',
        contactRemoved: '¡Contacto eliminado!',
        invoicesLoaded: '¡Facturas cargadas!',
        invoiceLoaded: '¡Factura cargada!',
        invoiceCreated: '¡Factura creada!',
        invoiceUpdated: '¡Factura actualizada!',
        invoicePaid: '¡Factura marcada como pagada!',
        invoiceCancelled: '¡Factura cancelada!',
        invoiceRemoved: '¡Factura eliminada!',
        dealsLoaded: '¡Negocios cargados!',
        dealLoaded: '¡Negocio cargado!',
        dealCreated: '¡Negocio creado con éxito!',
        dealUpdated: '¡Negocio actualizado con éxito!',
        dealRemoved: '¡Negocio eliminado!',
        productsLoaded: '¡Productos cargados!',
        productLoaded: '¡Producto cargado!',
        productCreated: '¡Producto creado con éxito!',
        productUpdated: '¡Producto actualizado con éxito!',
        productRemoved: '¡Producto eliminado!',
        usersLoaded: '¡Usuarios cargados!',
        userLoaded: '¡Usuario cargado!',
        userCreated: '¡Usuario creado con éxito!',
        userUpdated: '¡Usuario actualizado con éxito!',
        userRemoved: '¡Usuario eliminado!',
        servicesUpdated: '¡Servicios actualizados!',
        scheduleLoaded: '¡Agenda cargada!',
        scheduleCreated: '¡Agenda creada!',
        appointmentsLoaded: '¡Citas cargadas!',
        appointmentCreated: '¡Cita creada!',
        statusUpdated: '¡Estado actualizado!',
        tagsKanbanLoaded: '¡Etiquetas kanban cargadas!',
        tagKanbanLoaded: '¡Etiqueta kanban cargada!',
        tagKanbanCreated: '¡Etiqueta kanban creada con éxito!',
        tagKanbanUpdated: '¡Etiqueta kanban actualizada con éxito!',
        tagKanbanRemoved: '¡Etiqueta kanban eliminada!',
        ticketsLoaded: '¡Tickets cargados!',
        ticketLoaded: '¡Ticket cargado!',
        messagesLoaded: '¡Mensajes cargados!',
        ticketUpdated: '¡Ticket actualizado!',
        ticketClosed: '¡Ticket cerrado!',
        ticketReopened: '¡Ticket reabierto!',
        ticketTransferred: '¡Ticket transferido!',
      },
      backendErrorTokens: {
        ACCESS: 'acceso',
        ACTIVE: 'activo',
        ANNOUNCEMENT: 'anuncio',
        API: 'API',
        APP: 'aplicación',
        APPOINTMENT: 'cita',
        AUTH: 'autenticación',
        AUTOMATION: 'automatización',
        BRL: 'BRL',
        CAMPAIGN: 'campaña',
        CHAT: 'chat',
        CHATBOT: 'chatbot',
        CLIENT: 'cliente',
        CODE: 'código',
        COMPANY: 'empresa',
        CONFIGURED: 'configurado',
        CONNECTION: 'conexión',
        CONTACT: 'contacto',
        CREDENTIALS: 'credenciales',
        CREATION: 'creación',
        DELETE: 'eliminación',
        DISABLED: 'deshabilitado',
        DUPLICATED: 'duplicado',
        EMAIL: 'correo',
        EXPIRED: 'expirado',
        EXTERNAL: 'externo',
        FACEBOOK: 'Facebook',
        FATURA: 'factura',
        FETCH: 'búsqueda',
        FORBIDDEN: 'prohibido',
        FOUND: 'encontrado',
        INACTIVE: 'inactivo',
        INTEGRATIONS: 'integraciones',
        INTERNAL: 'interno',
        INVALID: 'inválido',
        MEDIA: 'media',
        MESSAGE: 'mensaje',
        MISSING: 'faltante',
        NAME: 'nombre',
        NO: 'ningún',
        NOT: 'no',
        OPENAI: 'OpenAI',
        PASSWORD: 'contraseña',
        PERMISSION: 'permiso',
        PLAN: 'plan',
        PROJECT: 'proyecto',
        QUEUE: 'cola',
        REQUIRED: 'obligatorio',
        ROUTE: 'ruta',
        SENDING: 'envío',
        SERVICE: 'servicio',
        SESSION: 'sesión',
        SUBSCRIPTION: 'suscripción',
        TAG: 'etiqueta',
        TASK: 'tarea',
        TICKET: 'ticket',
        TOKEN: 'token',
        USER: 'usuario',
        VALIDATION: 'validación',
        VALUE: 'valor',
        WAPP: 'WhatsApp',
        WHATSAPP: 'WhatsApp',
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: 'Debe haber al menos una conexión de WhatsApp predeterminada.',
        ERR_NO_DEF_WAPP_FOUND:
          'No se encontró WhatsApp predeterminado. Verifique la página de conexiones.',
        ERR_WAPP_NOT_INITIALIZED:
          'Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.',
        ERR_WAPP_CHECK_CONTACT:
          'No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.',
        ERR_WAPP_INVALID_CONTACT: 'Este no es un número de whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA:
          'No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.',
        ERR_INVALID_CREDENTIALS: 'Error de autenticación. Vuelva a intentarlo.',
        ERR_INVALID_TOKEN: 'Token inválido. Inicie sesión nuevamente.',
        ERR_SENDING_WAPP_MSG:
          'Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.',
        ERR_SENDING_FACEBOOK_MSG:
          'Error al enviar mensaje por Facebook/Instagram. Verifique la conexión.',
        instagram_does_not_support_this_media_type:
          'Instagram no admite este tipo de archivo. Envíe solo imágenes JPEG, PNG, GIF o WEBP.',
        ERR_DELETE_WAPP_MSG: 'No se pudo borrar el mensaje de WhatsApp.',
        ERR_OTHER_OPEN_TICKET: 'Ya hay un ticket abierto para este contacto.',
        ERR_SESSION_EXPIRED: 'Sesión caducada. Inicie sesión.',
        ERR_NO_AUTH_TOKEN: 'Solicitud sin token de autorización. Inicie sesión de nuevo.',
        ERR_ACCESS_TOKEN_EXPIRED: 'Token de acceso caducado. Actualice la página o inicie sesión.',
        ERR_REFRESH_TOKEN_MISSING: 'Refresh token ausente. Inicie sesión de nuevo.',
        ERR_REFRESH_TOKEN_EXPIRED: 'Refresh token caducado. Inicie sesión de nuevo.',
        ERR_REFRESH_TOKEN_INVALID: 'Refresh token inválido. Inicie sesión de nuevo.',
        ERR_SESSION_REVOKED:
          'Sesión revocada (ej. cierre de sesión en otro dispositivo). Inicie sesión de nuevo.',
        ERR_AUTH_REQUIRED: 'Autenticación requerida. Inicie sesión para continuar.',
        ERR_APP_NOT_ACTIVE:
          'La aplicación o integración no está activa. Revise la configuración o contacte al soporte.',
        ERR_PLAN_INTERNAL_CHAT_DISABLED:
          'El chat interno no está disponible en el plan actual de la empresa.',
        ERR_PLAN_INTEGRATIONS_DISABLED:
          'Las integraciones no están disponibles en el plan actual de la empresa.',
        ERR_COMPANY_APP_ALREADY_CANCELLED: 'Esta aplicación ya fue desactivada anteriormente.',
        ERR_COMPANY_TOKEN_MISSING: 'Token de empresa no proporcionado.',
        ERR_COMPANY_TOKEN_NOT_CONFIGURED: 'Token de empresa no configurado en el servidor.',
        ERR_COMPANY_TOKEN_INVALID: 'Token de empresa inválido.',
        ERR_API_TOKEN_MISSING: 'Token de API no proporcionado.',
        ERR_API_TOKEN_NOT_CONFIGURED: 'Integración sin token configurado.',
        ERR_API_TOKEN_INVALID: 'Token de API inválido.',
        ERR_USER_CREATION_DISABLED:
          'La creación de usuarios fue deshabilitada por el administrador.',
        ERR_NO_PERMISSION: 'No tienes permiso para acceder a este recurso.',
        ERR_DUPLICATED_CONTACT: 'Ya existe un contacto con este número.',
        ERR_NO_SETTING_FOUND: 'No se encontró ninguna configuración con este ID.',
        ERR_NO_CONTACT_FOUND: 'No se encontró ningún contacto con este ID.',
        ERR_NO_TICKET_FOUND: 'No se encontró ningún ticket con este ID.',
        ERR_NO_USER_FOUND: 'No se encontró ningún usuario con este ID.',
        ERR_NO_WAPP_FOUND: 'No se encontró WhatsApp con este ID.',
        ERR_CREATING_MESSAGE: 'Error al crear el mensaje en la base de datos.',
        ERR_CREATING_TICKET: 'Error al crear el ticket en la base de datos.',
        ERR_FETCH_WAPP_MSG:
          'Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'Este color ya está en uso, elija otro.',
        ERR_WAPP_GREETING_REQUIRED:
          'El mensaje de saludo es obligatorio cuando hay más de una fila.',
        ERR_OUT_OF_HOURS: '¡Fuera del horario de oficina!',
        ERR_EMAIL_ALREADY_EXISTS: 'Este correo ya está en uso.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'Este nombre de empresa ya está registrado.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'Este documento de empresa ya está registrado.',
        ERR_UNIQUE_CONSTRAINT_VIOLATION:
          'Ya existe un registro con ese valor. Verifique los campos e inténtelo de nuevo.',
        ERR_META_IMPORT_TOKEN_MISSING:
          'Conecte la página en Configuración > Conexiones antes de importar.',
        ERR_META_IMPORT_PAGE_NOT_FOUND:
          'Página no encontrada. Vincule la página en Configuración > Conexiones.',
        ERR_ROUTE_NOT_FOUND:
          'Ruta o recurso no encontrado. Verifique la dirección o inténtelo de nuevo.',
        ERR_CREATING_FOLLOW_UP:
          'No se pudo crear el follow-up. Verifique los datos e inténtelo de nuevo.',
        ERR_PASSWORD_RESET_CODE_INVALID:
          'Código inválido o expirado. Verifique el código o solicite uno nuevo.',
        ERR_PROMPT_INTELLIGENCE_INVALID:
          'La configuración de inteligencia de este prompt no es válida. Revise el modelo, herramientas y campos obligatorios.',
        missing_code_or_state: 'Autorización cancelada o expirada. Inténtelo de nuevo.',
        invalid_or_expired_state: 'La sesión de autorización expiró. Inicie el proceso nuevamente.',
        no_pages_found:
          'Su cuenta no administra ninguna Página de Facebook. Para usar el chat de Messenger o Instagram, debe ser administrador de una Página en Facebook.',
        subscribe_failed:
          'Página conectada, pero el webhook no se activó. Verifique que la app esté en modo Live.',
        token_exchange_failed: 'Error al autenticar la página. Intente reconectar.',
        conflict: 'Esta página ya está en uso por otra cuenta. Desconéctela antes de continuar.',
        ERR_CHAT_MESSAGE_DELETE_FORBIDDEN: 'Solo quien envió el mensaje puede eliminarlo.',
        ERR_REACTIONS_WHATSAPP_ONLY:
          'Las reacciones solo están disponibles en conversaciones de WhatsApp.',
        ERR_REACTIONS_INVALID_TARGET: 'No se puede reaccionar a este tipo de mensaje.',
        ERR_REACTIONS_NOT_AVAILABLE_PRIVATE: 'No se puede reaccionar a mensajes privados.',
        ERR_MESSAGE_KEY_UNAVAILABLE:
          'No se puede reaccionar: no hay datos/clave de WhatsApp disponibles para este mensaje.',
        ERR_SENDING_WAPP_REACTION:
          'Error al enviar la reacción por WhatsApp. Verifique la sesión e inténtelo de nuevo.',
        ERR_WAPP_NOT_CONNECTED: 'WhatsApp no está conectado. Verifique la página de conexiones.',
        ERR_CLIENT_REACTION_INVALID_MESSAGE_ID:
          'Espere a que el mensaje se guarde en el servidor antes de reaccionar.',
      },
    },
  },
};

export { messages };
